import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AbstractPersonRule = {
  __typename?: 'AbstractPersonRule';
  ruleType: Scalars['String'];
};

export type AcceptorPerson = {
  __typename?: 'AcceptorPerson';
  person?: Maybe<PublicPerson>;
  personId?: Maybe<Scalars['ID']>;
  roleUrn: Scalars['String'];
  text?: Maybe<LocalizedString>;
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  addressAsMarkupString?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityAsMarkupString?: Maybe<Scalars['String']>;
  country?: Maybe<Code>;
  countryUrn?: Maybe<Scalars['String']>;
  isUserEditable: Scalars['Boolean'];
  postalCode?: Maybe<Scalars['String']>;
  postalCodeAsMarkupString?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddressAsMarkupString?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Assessment = {
  __typename?: 'Assessment';
  additionalInfo?: Maybe<LocalizedString>;
  assessmentItemId?: Maybe<Scalars['ID']>;
  completionCredits?: Maybe<Scalars['Float']>;
  completionDate?: Maybe<Scalars['String']>;
  completionLanguageCode?: Maybe<Code>;
  completionLanguageUrn?: Maybe<Scalars['String']>;
  courseUnitRealisationId: Scalars['ID'];
  grade?: Maybe<Grade>;
  gradeId?: Maybe<Scalars['ID']>;
  person: PrivatePerson;
  personId: Scalars['ID'];
  personInfo: PersonInfo;
  verbalFeedback?: Maybe<Scalars['String']>;
};

export type AssessmentCollection = {
  __typename?: 'AssessmentCollection';
  assessments?: Maybe<Array<Assessment>>;
  courseUnitRealisationId: Scalars['ID'];
};

export type AssessmentItem = {
  __typename?: 'AssessmentItem';
  assessmentItemType: Scalars['String'];
  completionMethods?: Maybe<Array<CompletionMethod>>;
  contentDescription?: Maybe<LocalizedMarkupString>;
  courseUnitRealisations: Array<CourseUnitRealisation>;
  credits: CreditRange;
  documentState: Scalars['String'];
  gradeScaleId?: Maybe<Scalars['ID']>;
  grading?: Maybe<LocalizedString>;
  id: Scalars['ID'];
  learningMaterial?: Maybe<LocalizedMarkupString>;
  literature?: Maybe<Array<LocalId>>;
  name: LocalizedString;
  nameSpecifier?: Maybe<LocalizedString>;
  organisations?: Maybe<Array<CourseUnitRealisationOrganisation>>;
  possibleAttainmentLanguageUrns?: Maybe<Array<Scalars['String']>>;
  possibleAttainmentLanguages?: Maybe<Array<Code>>;
  primaryCourseUnitGroupId: Scalars['ID'];
  primaryCourseUnits: Array<CourseUnit>;
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  snapshotDateTime?: Maybe<Scalars['String']>;
  studyFormat?: Maybe<LocalizedMarkupString>;
  /** @deprecated AssessmentItem does not have study level */
  studyLevel?: Maybe<Code>;
  /** @deprecated AssessmentItem does not have study level */
  studyLevelUrn?: Maybe<Scalars['String']>;
  subject?: Maybe<Code>;
  subjectUrn?: Maybe<Scalars['String']>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
};


export type AssessmentItemCourseUnitRealisationsArgs = {
  activityStatus?: InputMaybe<Scalars['String']>;
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  flowStates?: InputMaybe<Array<Scalars['String']>>;
  removeCursPublishDateInFuture?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type AssociatedStudy = {
  __typename?: 'AssociatedStudy';
  associatedDegree: Scalars['String'];
  associatedDegreeAsMarkupString: Scalars['String'];
  attainmentDate: Scalars['String'];
  attainmentLocation?: Maybe<Code>;
  attainmentLocationUrn: Scalars['String'];
  credits: Scalars['Float'];
  description: Scalars['String'];
  descriptionAsMarkupString: Scalars['String'];
};

export type AttainableDegree = {
  __typename?: 'AttainableDegree';
  degreeName?: Maybe<Scalars['String']>;
  degreeNameAsMarkupString?: Maybe<Scalars['String']>;
  internationalInstitution?: Maybe<Code>;
  internationalInstitutionUrn: Scalars['String'];
};

export type AttainedQualification = {
  __typename?: 'AttainedQualification';
  additionalInformation?: Maybe<Scalars['String']>;
  additionalInformationAsMarkupString?: Maybe<Scalars['String']>;
  associatedStudies?: Maybe<Array<AssociatedStudy>>;
  attainmentDate?: Maybe<Scalars['String']>;
  childAttainedQualificationIds?: Maybe<Array<Scalars['ID']>>;
  childAttainedQualifications?: Maybe<Array<AttainedQualification>>;
  credits?: Maybe<Scalars['Float']>;
  documentState: Scalars['String'];
  educationalInstitution?: Maybe<Code>;
  educationalInstitutionUrn: Scalars['String'];
  id: Scalars['ID'];
  moduleGroupId: Scalars['ID'];
  personId: Scalars['ID'];
  qualification?: Maybe<Qualification>;
  qualificationId: Scalars['ID'];
  studyFieldUrn?: Maybe<Scalars['String']>;
  studyRight?: Maybe<StudyRight>;
  studyRightId?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
};


export type AttainedQualificationChildAttainedQualificationsArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type Attainment = {
  __typename?: 'Attainment';
  acceptorOrganisationIds?: Maybe<Array<Scalars['String']>>;
  acceptorOrganisations?: Maybe<Array<Organisation>>;
  acceptorPersons?: Maybe<Array<AcceptorPerson>>;
  activeGraduation?: Maybe<Graduation>;
  additionalInfo?: Maybe<LocalizedString>;
  assessmentItem?: Maybe<AssessmentItem>;
  assessmentItemAttainmentIds?: Maybe<Array<Scalars['ID']>>;
  assessmentItemId?: Maybe<Scalars['ID']>;
  assessmentItemSnapshot?: Maybe<AssessmentItem>;
  attainedQualifications?: Maybe<Array<AttainedQualification>>;
  attainmentDate: Scalars['String'];
  attainmentLanguage?: Maybe<Code>;
  attainmentLanguageCanonizedUrn?: Maybe<Scalars['String']>;
  attainmentLanguageUrn?: Maybe<Scalars['String']>;
  childAttainments?: Maybe<Array<Attainment>>;
  code?: Maybe<Scalars['String']>;
  codeAsMarkupString?: Maybe<Scalars['String']>;
  collaborationInstitution?: Maybe<CollaborationInstitution>;
  commissioned?: Maybe<Scalars['Boolean']>;
  courseUnit?: Maybe<CourseUnit>;
  courseUnitId?: Maybe<Scalars['ID']>;
  courseUnitRealisationId?: Maybe<Scalars['ID']>;
  courseUnitTypeUrn?: Maybe<Scalars['String']>;
  creditTransferInfo?: Maybe<CreditTransferInfo>;
  credits: Scalars['Float'];
  degreeTitle?: Maybe<Code>;
  degreeTitleUrn?: Maybe<Scalars['String']>;
  documentState: Scalars['String'];
  educationClassification?: Maybe<Code>;
  educationClassificationUrn?: Maybe<Scalars['String']>;
  educationalInstitution?: Maybe<Code>;
  educationalInstitutionUrn: Scalars['String'];
  embeddedModules?: Maybe<Array<EmbeddedModule>>;
  enrolmentRight?: Maybe<EnrolmentRight>;
  enrolmentRightId?: Maybe<Scalars['ID']>;
  enrolmentRightIdResolved?: Maybe<Scalars['ID']>;
  expiryDate?: Maybe<Scalars['String']>;
  grade?: Maybe<Grade>;
  gradeAverage?: Maybe<GradeAverage>;
  gradeId: Scalars['ID'];
  gradeScale?: Maybe<GradeScale>;
  gradeScaleId: Scalars['ID'];
  honoraryTitle?: Maybe<Code>;
  honoraryTitleUrn?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internationalContractualDegree?: Maybe<InternationalContractualDegree>;
  misregistration: Scalars['Boolean'];
  misregistrationRationale?: Maybe<Scalars['String']>;
  misregistrationRationaleAsMarkupString?: Maybe<Scalars['String']>;
  module?: Maybe<Module>;
  moduleGroupId?: Maybe<Scalars['ID']>;
  moduleId?: Maybe<Scalars['ID']>;
  name?: Maybe<LocalizedString>;
  nodes?: Maybe<Array<AttainmentNode>>;
  organisations?: Maybe<Array<OrganisationShare>>;
  person: PrivatePerson;
  personFirstNames?: Maybe<Scalars['String']>;
  personFirstNamesAsMarkupString?: Maybe<Scalars['String']>;
  personId: Scalars['ID'];
  personInfo: PersonInfo;
  personLastName?: Maybe<Scalars['String']>;
  personLastNameAsMarkupString?: Maybe<Scalars['String']>;
  personStudentNumber?: Maybe<Scalars['String']>;
  personStudentNumberAsMarkupString?: Maybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  rdiCredits?: Maybe<Scalars['Float']>;
  registrationDate: Scalars['String'];
  secondaryEducationClassification?: Maybe<Code>;
  secondaryEducationClassificationUrn?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  studyField?: Maybe<Code>;
  studyFieldUrn?: Maybe<Scalars['String']>;
  studyRight?: Maybe<StudyRight>;
  studyRightId?: Maybe<Scalars['ID']>;
  studyWeeks?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  verbalFeedback?: Maybe<Scalars['String']>;
  verifierPerson?: Maybe<PublicPerson>;
  verifierPersonId?: Maybe<Scalars['ID']>;
};


export type AttainmentAttainedQualificationsArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type AttainmentExportResult = {
  __typename?: 'AttainmentExportResult';
  greatestOrdinal: Scalars['Float'];
  greatestThesisOrdinal: Scalars['Float'];
  hasMore: Scalars['Boolean'];
  ids?: Maybe<Array<Scalars['String']>>;
};

export type AttainmentInfo = {
  __typename?: 'AttainmentInfo';
  attainmentId: Scalars['ID'];
  attainmentType: Scalars['String'];
  studyFieldUrn?: Maybe<Scalars['String']>;
};

export type AttainmentNode = {
  __typename?: 'AttainmentNode';
  attainment?: Maybe<Attainment>;
  attainmentId?: Maybe<Scalars['ID']>;
  name?: Maybe<LocalizedString>;
  nodes?: Maybe<Array<AttainmentNode>>;
  type?: Maybe<Scalars['String']>;
};

export type Building = {
  __typename?: 'Building';
  address?: Maybe<Address>;
  documentState: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<LocalizedString>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
};

export type Code = {
  __typename?: 'Code';
  deprecated?: Maybe<Scalars['Boolean']>;
  exceptionalVirtaValue?: Maybe<Scalars['String']>;
  name: LocalizedString;
  shortName?: Maybe<LocalizedString>;
  urn: Scalars['String'];
};

/** Collaboration institution that defines a national or foreign institution */
export type CollaborationInstitution = {
  __typename?: 'CollaborationInstitution';
  educationalInstitution?: Maybe<Code>;
  educationalInstitutionUrn?: Maybe<Scalars['String']>;
  internationalInstitutionUrn?: Maybe<Scalars['String']>;
};

export type CompletionMethod = {
  __typename?: 'CompletionMethod';
  assessmentItemIds: Array<Scalars['ID']>;
  assessmentItemOptionalityDescription?: Maybe<LocalizedMarkupString>;
  assessmentItems: Array<AssessmentItem>;
  automaticEvaluation: Scalars['Boolean'];
  courseUnit: CourseUnit;
  description?: Maybe<LocalizedMarkupString>;
  evaluationCriteria?: Maybe<LocalizedString>;
  prerequisites?: Maybe<LocalizedString>;
  repeats?: Maybe<Array<CompletionMethodRepeat>>;
  require?: Maybe<Range>;
  studyType: Scalars['String'];
  typeOfRequire: Scalars['String'];
};

export type CompletionMethodRepeat = {
  __typename?: 'CompletionMethodRepeat';
  repeatPossibility?: Maybe<Array<StudyPeriodTemplateLocator>>;
  repeatPossibilityString?: Maybe<Array<Scalars['String']>>;
  studyYearRange: YearRange;
  yearInterval?: Maybe<Scalars['Int']>;
};

export type ContentFilter = {
  __typename?: 'ContentFilter';
  studyRightSelectionType?: Maybe<Code>;
  studyRightSelectionTypeUrn?: Maybe<Scalars['String']>;
};

export enum CooperationNetworkSearchType {
  CourseUnits = 'COURSE_UNITS',
  CourseUnitsCombinedWithCooperationNetworks = 'COURSE_UNITS_COMBINED_WITH_COOPERATION_NETWORKS'
}

export type CountryCode = {
  __typename?: 'CountryCode';
  alpha2?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  exceptionalVirtaValue?: Maybe<Scalars['String']>;
  name: LocalizedString;
  numeric: Scalars['String'];
  shortName?: Maybe<LocalizedString>;
  urn: Scalars['String'];
};

export type CourseUnit = {
  __typename?: 'CourseUnit';
  abbreviation?: Maybe<Scalars['String']>;
  abbreviationAsMarkupString?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<LocalizedMarkupString>;
  approvalState?: Maybe<Scalars['String']>;
  assessmentItemOrder?: Maybe<Array<Scalars['String']>>;
  categoryTagUrns?: Maybe<Array<Scalars['String']>>;
  categoryTags?: Maybe<Array<Code>>;
  cefrLevel?: Maybe<Code>;
  cefrLevelUrn?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeAsMarkupString?: Maybe<Scalars['String']>;
  completionMethods?: Maybe<Array<CompletionMethod>>;
  compulsoryFormalPrerequisites?: Maybe<Array<PrerequisiteGroup>>;
  content?: Maybe<LocalizedMarkupString>;
  courseUnitRealisations?: Maybe<Array<CourseUnitRealisation>>;
  courseUnitType?: Maybe<Code>;
  courseUnitTypeUrn?: Maybe<Scalars['String']>;
  credits?: Maybe<CreditRange>;
  curriculumPeriodIds?: Maybe<Array<Scalars['ID']>>;
  curriculumPeriods?: Maybe<Array<CurriculumPeriod>>;
  customCodeUrns?: Maybe<Array<Scalars['String']>>;
  documentState: Scalars['String'];
  equivalentCoursesInfo?: Maybe<LocalizedMarkupString>;
  gradeScale?: Maybe<GradeScale>;
  gradeScaleId?: Maybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  inclusionApplicationInstruction?: Maybe<LocalizedMarkupString>;
  learningMaterial?: Maybe<LocalizedMarkupString>;
  literature?: Maybe<Array<Literature>>;
  name?: Maybe<LocalizedString>;
  openUniversityProducts?: Maybe<Array<OpenUniversityProduct>>;
  organisations?: Maybe<Array<CourseUnitRealisationOrganisation>>;
  outcomes?: Maybe<LocalizedMarkupString>;
  possibleAttainmentLanguageUrns?: Maybe<Array<Scalars['String']>>;
  possibleAttainmentLanguages?: Maybe<Array<Code>>;
  prerequisites?: Maybe<LocalizedMarkupString>;
  recommendedFormalPrerequisites?: Maybe<Array<PrerequisiteGroup>>;
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  s2r2Classification?: Maybe<Scalars['String']>;
  searchTags?: Maybe<Array<Scalars['String']>>;
  studyFieldUrns?: Maybe<Array<Scalars['String']>>;
  studyFields?: Maybe<Array<Code>>;
  studyLevel?: Maybe<Code>;
  studyLevelUrn?: Maybe<Scalars['String']>;
  subject?: Maybe<Code>;
  subjectUrn?: Maybe<Scalars['String']>;
  substitutions?: Maybe<Array<Substitution>>;
  tweetText?: Maybe<LocalizedString>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
  validityPeriod?: Maybe<DatePeriod>;
};


export type CourseUnitCourseUnitRealisationsArgs = {
  activityStatus?: InputMaybe<Scalars['String']>;
  flowStates?: InputMaybe<Array<Scalars['String']>>;
};

export type CourseUnitRealisation = {
  __typename?: 'CourseUnitRealisation';
  activityPeriod: DatePeriod;
  activityPeriodEndDateSubtractedByOneDay?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<LocalizedMarkupString>;
  assessmentCollection?: Maybe<AssessmentCollection>;
  assessmentItemIds?: Maybe<Array<Scalars['ID']>>;
  assessmentItems?: Maybe<Array<AssessmentItem>>;
  assessments?: Maybe<Array<Assessment>>;
  attainments?: Maybe<Array<Attainment>>;
  continuousEnrolment: Scalars['Boolean'];
  courseUnitRealisationType?: Maybe<Code>;
  courseUnitRealisationTypeUrn?: Maybe<Scalars['String']>;
  courseUnits?: Maybe<Array<CourseUnit>>;
  documentState: Scalars['String'];
  enrolledEnrolmentCount?: Maybe<Scalars['Int']>;
  enrolmentAdditionalCancellationEnd?: Maybe<Scalars['String']>;
  enrolmentCalculationConfig?: Maybe<EnrolmentCalculationConfig>;
  enrolmentPeriod?: Maybe<DateTimePeriod>;
  enrolmentQuestionnaire?: Maybe<EnrolmentQuestionnaire>;
  enrolments?: Maybe<Array<Enrolment>>;
  externalEnrolmentLink?: Maybe<Link>;
  flowState?: Maybe<Scalars['String']>;
  gradeDistributions?: Maybe<Array<GradeDistribution>>;
  id: Scalars['ID'];
  lateEnrolmentEnd?: Maybe<Scalars['String']>;
  learningEnvironmentDescription?: Maybe<LocalizedString>;
  learningEnvironments?: Maybe<Array<LearningEnvironment>>;
  learningMaterial?: Maybe<LocalizedMarkupString>;
  literature?: Maybe<Array<Literature>>;
  name?: Maybe<LocalizedString>;
  nameSpecifier?: Maybe<LocalizedString>;
  organisations?: Maybe<Array<CourseUnitRealisationOrganisation>>;
  publishDate?: Maybe<Scalars['String']>;
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  studyFormat?: Maybe<LocalizedMarkupString>;
  studyGroupSets?: Maybe<Array<StudyGroupSet>>;
  teachingLanguage?: Maybe<Code>;
  teachingLanguageUrn?: Maybe<Scalars['String']>;
  totalEnrolmentCount?: Maybe<Scalars['Int']>;
  tweetText?: Maybe<LocalizedString>;
  unconfirmedEnrolmentCount?: Maybe<Scalars['Int']>;
  universityOrgIds: Array<Scalars['ID']>;
  universityOrgs?: Maybe<Array<Organisation>>;
  usesExternalEnrolment: Scalars['Boolean'];
};

export type CourseUnitRealisationFullResultItem = {
  __typename?: 'CourseUnitRealisationFullResultItem';
  code: Scalars['String'];
  courseUnitCodes?: Maybe<Scalars['String']>;
  courseUnitRealisation?: Maybe<CourseUnitRealisation>;
  id: Scalars['String'];
  lang: Scalars['String'];
  langMatch?: Maybe<Scalars['String']>;
  name?: Maybe<LocalizedString>;
  nameSpecifier?: Maybe<LocalizedString>;
};

export type CourseUnitRealisationOrganisation = {
  __typename?: 'CourseUnitRealisationOrganisation';
  educationalInstitution?: Maybe<Code>;
  educationalInstitutionUrn?: Maybe<Scalars['String']>;
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['ID'];
  roleUrn?: Maybe<Scalars['String']>;
  share?: Maybe<Scalars['Float']>;
  validityPeriod?: Maybe<DatePeriod>;
};

export type CourseUnitRealisationTeacherSearchResult = {
  __typename?: 'CourseUnitRealisationTeacherSearchResult';
  hiddenTotal: Scalars['Float'];
  limit: Scalars['Float'];
  searchResults: Array<CourseUnitRealisationFullResultItem>;
  start: Scalars['Float'];
  total: Scalars['Float'];
  truncated: Scalars['Boolean'];
};

export type CourseUnitSubstitution = {
  __typename?: 'CourseUnitSubstitution';
  courseUnitGroupId: Scalars['ID'];
  courseUnits?: Maybe<Array<CourseUnit>>;
  credits?: Maybe<Scalars['Float']>;
};


export type CourseUnitSubstitutionCourseUnitsArgs = {
  universityOrgId: Scalars['ID'];
};

export type CourseUnitTiming = {
  __typename?: 'CourseUnitTiming';
  courseUnit?: Maybe<CourseUnit>;
  courseUnitGroupId: Scalars['ID'];
  plannedPeriods: Array<StudyPeriodLocator>;
  plannedPeriodsAsStrings: Array<Scalars['String']>;
};


export type CourseUnitTimingCourseUnitArgs = {
  curriculumPeriodId: Scalars['String'];
  universityOrgId: Scalars['String'];
};

export type CreditRange = {
  __typename?: 'CreditRange';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type CreditTransferInfo = {
  __typename?: 'CreditTransferInfo';
  creditTransferDate?: Maybe<Scalars['String']>;
  educationalInstitution?: Maybe<Code>;
  educationalInstitutionUrn?: Maybe<Scalars['String']>;
  internationalInstitution?: Maybe<Code>;
  internationalInstitutionUrn?: Maybe<Scalars['String']>;
  organisation?: Maybe<Scalars['String']>;
  organisationAsMarkupString?: Maybe<Scalars['String']>;
};

export type CurriculumPeriod = {
  __typename?: 'CurriculumPeriod';
  abbreviation: LocalizedString;
  activePeriod: DatePeriod;
  id: Scalars['ID'];
  name: LocalizedString;
  universityOrgId?: Maybe<Scalars['ID']>;
};

export type DatePeriod = {
  __typename?: 'DatePeriod';
  endDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
};

export type DatePeriodInput = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type DateTimePeriod = {
  __typename?: 'DateTimePeriod';
  endDateTime?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['String']>;
};

export type DegreeProgramme = {
  __typename?: 'DegreeProgramme';
  abbreviation?: Maybe<Scalars['String']>;
  abbreviationAsMarkupString?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<LocalizedMarkupString>;
  approvalState?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeAsMarkupString?: Maybe<Scalars['String']>;
  contentDescription?: Maybe<LocalizedMarkupString>;
  curriculumPeriodIds?: Maybe<Array<Scalars['ID']>>;
  curriculumPeriods?: Maybe<Array<CurriculumPeriod>>;
  customCodeUrns?: Maybe<Array<Scalars['String']>>;
  customCodes?: Maybe<Array<Code>>;
  degreeLanguageUrns: Array<Scalars['String']>;
  degreeLanguages?: Maybe<Array<Code>>;
  degreeProgrammeType?: Maybe<Code>;
  degreeProgrammeTypeUrn?: Maybe<Scalars['String']>;
  degreeTitleUrns: Array<Scalars['String']>;
  degreeTitles?: Maybe<Array<Code>>;
  documentState: Scalars['String'];
  educationClassificationUrns: Array<Scalars['String']>;
  educationClassifications?: Maybe<Array<Code>>;
  educationLocationUrns?: Maybe<Array<Scalars['String']>>;
  educationLocations?: Maybe<Array<Code>>;
  gradeScale?: Maybe<GradeScale>;
  gradeScaleId?: Maybe<Scalars['ID']>;
  graded: Scalars['Boolean'];
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  inclusionApplicationInstruction?: Maybe<LocalizedMarkupString>;
  learningOutcomes?: Maybe<LocalizedMarkupString>;
  moduleContentApprovalRequired: Scalars['Boolean'];
  name?: Maybe<LocalizedString>;
  organisations?: Maybe<Array<OrganisationShare>>;
  outcomes?: Maybe<LocalizedMarkupString>;
  possibleAttainmentLanguageUrns?: Maybe<Array<Scalars['String']>>;
  possibleAttainmentLanguages?: Maybe<Array<Code>>;
  prerequisites?: Maybe<LocalizedMarkupString>;
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  rule?: Maybe<Rule>;
  searchTags?: Maybe<Array<Scalars['String']>>;
  studyFieldUrns?: Maybe<Array<Scalars['String']>>;
  studyFields?: Maybe<Array<Code>>;
  studyLevel?: Maybe<Code>;
  studyLevelUrn?: Maybe<Scalars['String']>;
  targetCredits?: Maybe<CreditRange>;
  timingTemplates: Array<TimingTemplate>;
  tweetText?: Maybe<LocalizedString>;
  type?: Maybe<Scalars['String']>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
  validityPeriod?: Maybe<DatePeriod>;
};

export type Education = {
  __typename?: 'Education';
  attainmentLanguageUrns?: Maybe<Array<Scalars['String']>>;
  attainmentLanguages?: Maybe<Array<Code>>;
  code?: Maybe<Scalars['String']>;
  codeAsMarkupString?: Maybe<Scalars['String']>;
  defaultStudyRightExpirationRulesUrn?: Maybe<Scalars['String']>;
  documentState: Scalars['String'];
  educationLocation?: Maybe<Code>;
  educationLocationUrn?: Maybe<Scalars['String']>;
  educationType?: Maybe<Code>;
  educationTypeUrn: Scalars['String'];
  fundingSourceEducation?: Maybe<Code>;
  fundingSourceEducationUrn?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  isMultiformEducation?: Maybe<Scalars['Boolean']>;
  name?: Maybe<LocalizedString>;
  organisations?: Maybe<Array<CourseUnitRealisationOrganisation>>;
  outcomes?: Maybe<LocalizedMarkupString>;
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  rule?: Maybe<Rule>;
  specialisationStudiesClassificationUrn?: Maybe<Scalars['String']>;
  structure: EducationStructure;
  studyFieldUrns?: Maybe<Array<Scalars['String']>>;
  studyFields?: Maybe<Array<Code>>;
  studySelectionRequirement: Scalars['String'];
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
  validityPeriod?: Maybe<DatePeriod>;
};

export type EducationChildOption = {
  __typename?: 'EducationChildOption';
  acceptanceType: Scalars['String'];
  degreeTitle?: Maybe<Code>;
  degreeTitleUrn?: Maybe<Scalars['String']>;
  educationClassification?: Maybe<Code>;
  educationClassificationUrn?: Maybe<Scalars['String']>;
  localId: Scalars['ID'];
  moduleGroupId: Scalars['ID'];
};

export type EducationOption = {
  __typename?: 'EducationOption';
  acceptanceType: Scalars['String'];
  childNaming?: Maybe<Code>;
  childNamingUrn: Scalars['String'];
  childOptions: Array<EducationChildOption>;
  degreeTitle?: Maybe<Code>;
  degreeTitleUrn?: Maybe<Scalars['String']>;
  educationClassification?: Maybe<Code>;
  educationClassificationUrn?: Maybe<Scalars['String']>;
  localId: Scalars['ID'];
  moduleGroup: ModuleGroup;
  moduleGroupId: Scalars['ID'];
};

export type EducationPhase = {
  __typename?: 'EducationPhase';
  name?: Maybe<LocalizedString>;
  options: Array<EducationOption>;
};

export type EducationStructure = {
  __typename?: 'EducationStructure';
  learningOpportunities: Array<LearningOpportunity>;
  phase1: EducationPhase;
  phase2?: Maybe<EducationPhase>;
};

export type EducationTypeTermRegistrationRequirements = {
  __typename?: 'EducationTypeTermRegistrationRequirements';
  educationTypeUrn: Scalars['String'];
  studentUnionMembershipFeeRequirement: Scalars['String'];
};

export type ElectronicSignatureImage = {
  __typename?: 'ElectronicSignatureImage';
  fileType?: Maybe<Scalars['String']>;
  nameOfImage?: Maybe<Scalars['String']>;
  signatureImageBase64?: Maybe<Scalars['String']>;
  signatureOwnerId: Scalars['ID'];
};

export type EmbeddedModule = {
  __typename?: 'EmbeddedModule';
  module?: Maybe<Module>;
  moduleGroupId: Scalars['ID'];
  moduleId: Scalars['ID'];
};

export enum EmployeeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export type Enrolment = {
  __typename?: 'Enrolment';
  allocatedQuota?: Maybe<EnrolmentSelectedUsersQuota>;
  allocatedQuotaId?: Maybe<Scalars['ID']>;
  assessmentItem?: Maybe<AssessmentItem>;
  assessmentItemId?: Maybe<Scalars['ID']>;
  confirmedStudySubGroupIds?: Maybe<Array<Scalars['ID']>>;
  courseUnit?: Maybe<CourseUnit>;
  courseUnitId?: Maybe<Scalars['ID']>;
  courseUnitRealisation?: Maybe<CourseUnitRealisation>;
  courseUnitRealisationId?: Maybe<Scalars['ID']>;
  credits?: Maybe<Scalars['Float']>;
  enrolmentDateTime?: Maybe<Scalars['String']>;
  enrolmentQuestionnaireAnswers?: Maybe<EnrolmentQuestionnaireAnswers>;
  enrolmentRightId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isInCalendar?: Maybe<Scalars['Boolean']>;
  maximumQuotaIds?: Maybe<Array<Scalars['ID']>>;
  openUniversityCart?: Maybe<OpenUniversityCart>;
  openUniversityCartId?: Maybe<Scalars['ID']>;
  openUniversityCartItem?: Maybe<OpenUniversityCartItem>;
  openUniversityCartItemId?: Maybe<Scalars['ID']>;
  person?: Maybe<PrivatePerson>;
  personId?: Maybe<Scalars['ID']>;
  personInfo?: Maybe<PersonInfo>;
  privatePersonBasicInfo?: Maybe<PrivatePersonBasicInfo>;
  processingState?: Maybe<Scalars['String']>;
  selectionCriteria?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studyRight?: Maybe<StudyRight>;
  studyRightId?: Maybe<Scalars['ID']>;
  studySubGroups?: Maybe<Array<EnrolmentStudySubGroup>>;
  tentativeStudySubGroupIds?: Maybe<Array<Scalars['ID']>>;
};

export type EnrolmentCalculationConfig = {
  __typename?: 'EnrolmentCalculationConfig';
  manualConfirmation: Scalars['Boolean'];
  maxSelected?: Maybe<Scalars['Int']>;
  maximumUsersQuotas?: Maybe<Array<EnrolmentMaximumUsersQuota>>;
  orderingPersonRules?: Maybe<Array<PersonRule>>;
  requirementPersonRules?: Maybe<Array<PersonRule>>;
  selectedUsersQuotas?: Maybe<Array<EnrolmentSelectedUsersQuota>>;
};

/** EnrolmentConstraints can be used to define to which CourseUnitRealisations the student may enroll. */
export type EnrolmentConstraint = {
  __typename?: 'EnrolmentConstraint';
  allPossibleCourseUnitRealisations?: Maybe<Array<CourseUnitRealisation>>;
  allowedCourseUnitRealisationIds?: Maybe<Array<Scalars['ID']>>;
  allowedCourseUnitRealisations?: Maybe<Array<CourseUnitRealisation>>;
  assessmentItem?: Maybe<AssessmentItem>;
  assessmentItemId: Scalars['ID'];
  enrolmentCount?: Maybe<Scalars['Int']>;
  maxNumberOfEnrolments?: Maybe<Scalars['Int']>;
  overrideEnrolmentPeriodCURs?: Maybe<Array<CourseUnitRealisation>>;
  overrideEnrolmentPeriodForCURIds?: Maybe<Array<Scalars['ID']>>;
};

export type EnrolmentMaximumUsersQuota = {
  __typename?: 'EnrolmentMaximumUsersQuota';
  id: Scalars['ID'];
  name: LocalizedString;
  quotaPersonRules: Array<AbstractPersonRule>;
  size: Scalars['Int'];
};

export type EnrolmentQuestion = {
  __typename?: 'EnrolmentQuestion';
  localId: Scalars['ID'];
  question?: Maybe<LocalizedMarkupString>;
  questionType?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  selections?: Maybe<Array<EnrolmentQuestionSelect>>;
};

export type EnrolmentQuestionAnswer = {
  __typename?: 'EnrolmentQuestionAnswer';
  answerText?: Maybe<Scalars['String']>;
  answerTextAsMarkupString?: Maybe<Scalars['String']>;
  questionId: Scalars['ID'];
  selections?: Maybe<Array<Scalars['String']>>;
  /** The values in the selections field can be URNs. If they are, this field will contain the resolved Code values. */
  selectionsAsCodes?: Maybe<Array<Code>>;
};

export type EnrolmentQuestionSelect = {
  __typename?: 'EnrolmentQuestionSelect';
  option: LocalizedString;
  value: Scalars['String'];
};

export type EnrolmentQuestionnaire = {
  __typename?: 'EnrolmentQuestionnaire';
  courseUnitRealisationId: Scalars['ID'];
  documentState?: Maybe<Scalars['String']>;
  enrolmentQuestions?: Maybe<Array<EnrolmentQuestion>>;
};

export type EnrolmentQuestionnaireAnswers = {
  __typename?: 'EnrolmentQuestionnaireAnswers';
  answers?: Maybe<Array<EnrolmentQuestionAnswer>>;
  courseUnitRealisationId?: Maybe<Scalars['ID']>;
  documentState?: Maybe<Scalars['String']>;
  enrolmentId: Scalars['ID'];
  studentId: Scalars['ID'];
};

export type EnrolmentRight = {
  __typename?: 'EnrolmentRight';
  attainmentInfo?: Maybe<AttainmentInfo>;
  cancellationDate?: Maybe<Scalars['String']>;
  collaborationInstitution?: Maybe<CollaborationInstitution>;
  completionMethodId?: Maybe<Scalars['ID']>;
  courseUnit?: Maybe<CourseUnit>;
  courseUnitGroupId: Scalars['ID'];
  courseUnitId: Scalars['ID'];
  documentState: Scalars['String'];
  id: Scalars['ID'];
  module?: Maybe<Module>;
  openUniversityCartId?: Maybe<Scalars['ID']>;
  openUniversityCartItemId?: Maybe<Scalars['ID']>;
  openUniversityProductId?: Maybe<Scalars['ID']>;
  personId: Scalars['ID'];
  state: Scalars['String'];
  studyRight?: Maybe<StudyRight>;
  studyRightId: Scalars['ID'];
  validityPeriod: DatePeriod;
};


export type EnrolmentRightModuleArgs = {
  universityOrgId: Scalars['ID'];
};

export type EnrolmentSelectedUsersQuota = {
  __typename?: 'EnrolmentSelectedUsersQuota';
  id: Scalars['ID'];
  name: LocalizedString;
  quotaPersonRules: Array<AbstractPersonRule>;
  size: Scalars['Int'];
};

export type EnrolmentStudySubGroup = {
  __typename?: 'EnrolmentStudySubGroup';
  enrolmentStudySubGroupPriority?: Maybe<Scalars['String']>;
  isInCalendar: Scalars['Boolean'];
  studySubGroupId: Scalars['ID'];
};

export type EnrolmentWithStudyEvents = {
  __typename?: 'EnrolmentWithStudyEvents';
  enrolment: Enrolment;
  studyEvents?: Maybe<Array<StudyEvent>>;
};

export type EventOverride = {
  __typename?: 'EventOverride';
  eventDate: Scalars['String'];
  irregularLocationIds?: Maybe<Array<Scalars['ID']>>;
  irregularLocations?: Maybe<Array<Location>>;
  irregularTeacherIds?: Maybe<Array<Scalars['ID']>>;
  irregularTeachers?: Maybe<Array<PublicPerson>>;
  notice?: Maybe<LocalizedString>;
  noticeAsMarkupString?: Maybe<LocalizedMarkupString>;
};

export type ExportIdResult = {
  __typename?: 'ExportIdResult';
  greatestOrdinal?: Maybe<Scalars['Float']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  ids: Array<Scalars['ID']>;
};

export type ExportResult = {
  __typename?: 'ExportResult';
  greatestOrdinal: Scalars['Float'];
  hasMore: Scalars['Boolean'];
  ids: Array<Scalars['String']>;
};

export type Grade = {
  __typename?: 'Grade';
  abbreviation?: Maybe<LocalizedString>;
  localId: Scalars['ID'];
  name: LocalizedString;
  numericCorrespondence?: Maybe<Scalars['Float']>;
  passed: Scalars['Boolean'];
};

export type GradeAverage = {
  __typename?: 'GradeAverage';
  gradeScaleId: Scalars['ID'];
  method: Scalars['String'];
  totalIncludedCredits?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type GradeCount = {
  __typename?: 'GradeCount';
  gradeCount: Scalars['Float'];
  gradeId: Scalars['String'];
};

export type GradeCountFull = {
  __typename?: 'GradeCountFull';
  grade: Grade;
  gradeCount: Scalars['Float'];
  gradeId: Scalars['String'];
};

export type GradeDistribution = {
  __typename?: 'GradeDistribution';
  assessmentItem: AssessmentItem;
  assessmentItemId: Scalars['String'];
  gradeCounts: Array<GradeCount>;
  gradeCountsWithGrades: Array<GradeCountFull>;
  gradeScale: GradeScale;
  gradeScaleId: Scalars['String'];
};

export type GradeScale = {
  __typename?: 'GradeScale';
  abbreviation: LocalizedString;
  grades: Array<Grade>;
  id: Scalars['ID'];
  name: LocalizedString;
};

export type Graduation = {
  __typename?: 'Graduation';
  degreeDeliveryMethod: Scalars['String'];
  degreeProgrammeAttainment?: Maybe<Attainment>;
  degreeProgrammeAttainmentId: Scalars['ID'];
  deliveryAddress?: Maybe<Address>;
  documentState: Scalars['String'];
  graduationDate: Scalars['String'];
  id: Scalars['ID'];
  joinsAlumniAssociation?: Maybe<Scalars['Boolean']>;
  misregistration: Scalars['Boolean'];
  person?: Maybe<PrivatePerson>;
  personId: Scalars['ID'];
  printLanguageUrns?: Maybe<Array<Scalars['String']>>;
  printLanguages?: Maybe<Array<Code>>;
  signatories?: Maybe<Array<Signatory>>;
  storedDocuments?: Maybe<Array<StoredDocument>>;
  studyRight?: Maybe<StudyRight>;
  studyRightId: Scalars['ID'];
};


export type GraduationStoredDocumentsArgs = {
  documentTypes?: InputMaybe<Array<Scalars['String']>>;
  draft?: InputMaybe<Scalars['Boolean']>;
  hasElectronicSignatures?: InputMaybe<Scalars['Boolean']>;
};

export type Grant = {
  __typename?: 'Grant';
  amount?: Maybe<Scalars['Float']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelled: Scalars['Boolean'];
  cancelledBy?: Maybe<PrivatePerson>;
  cancelledById?: Maybe<Scalars['ID']>;
  cancelledDate?: Maybe<Scalars['String']>;
  documentState: Scalars['String'];
  grantType?: Maybe<Code>;
  grantTypeUrn?: Maybe<Scalars['String']>;
  grantedBy?: Maybe<Organisation>;
  grantedById?: Maybe<Scalars['ID']>;
  grantedDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  person?: Maybe<PrivatePerson>;
  personId: Scalars['ID'];
  registeredBy?: Maybe<PrivatePerson>;
  registeredById?: Maybe<Scalars['ID']>;
  registrationDate?: Maybe<Scalars['String']>;
  studyRight?: Maybe<StudyRight>;
  studyRightId?: Maybe<Scalars['ID']>;
  studyTerm?: Maybe<StudyTerm>;
  studyTermLocator?: Maybe<StudyTermLocator>;
};

export type HiddenTeaching = {
  __typename?: 'HiddenTeaching';
  courseUnitRealisationId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type InternationalContractualDegree = {
  __typename?: 'InternationalContractualDegree';
  attainableDegrees: Array<AttainableDegree>;
  internationalContractualDegreeAgreement?: Maybe<InternationalContractualDegreeAgreement>;
  internationalContractualDegreeAgreementId: Scalars['ID'];
  localId: Scalars['ID'];
};

export type InternationalContractualDegreeAgreement = {
  __typename?: 'InternationalContractualDegreeAgreement';
  defaultInternationalInstitutionUrns?: Maybe<Array<Scalars['String']>>;
  defaultInternationalInstitutions?: Maybe<Array<Code>>;
  diplomaDescriptionBegin: LocalizedString;
  diplomaDescriptionEnd: LocalizedString;
  diplomaSupplementAdministeringInstitutions?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: LocalizedString;
  type: Scalars['String'];
};

export type LearningEnvironment = {
  __typename?: 'LearningEnvironment';
  language?: Maybe<Scalars['String']>;
  languageAsMarkupString?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameAsMarkupString?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  urlAsMarkupString?: Maybe<Scalars['String']>;
};

export type LearningOpportunity = {
  __typename?: 'LearningOpportunity';
  admissionTargetIds?: Maybe<Array<Scalars['String']>>;
  allowedPaths: Array<SelectionPath>;
  localId: Scalars['String'];
  name: LocalizedString;
  phase1EducationClassification?: Maybe<Code>;
  phase1EducationClassificationUrn?: Maybe<Scalars['String']>;
  phase2EducationClassification?: Maybe<Code>;
  phase2EducationClassificationUrn?: Maybe<Scalars['String']>;
};

export type Link = {
  __typename?: 'Link';
  label?: Maybe<LocalizedString>;
  url?: Maybe<LocalizedString>;
};

export type Literature = {
  __typename?: 'Literature';
  name?: Maybe<Scalars['String']>;
  nameAsMarkupString?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  urlAsMarkupString?: Maybe<Scalars['String']>;
};

export type LocalId = {
  __typename?: 'LocalId';
  localId: Scalars['ID'];
};

export type LocalizedMarkupString = {
  __typename?: 'LocalizedMarkupString';
  en?: Maybe<Scalars['String']>;
  fi?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  en?: Maybe<Scalars['String']>;
  enAsMarkupString?: Maybe<Scalars['String']>;
  fi?: Maybe<Scalars['String']>;
  fiAsMarkupString?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
  svAsMarkupString?: Maybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  building?: Maybe<Building>;
  buildingId?: Maybe<Scalars['ID']>;
  capacity?: Maybe<Scalars['Int']>;
  documentState: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<LocalizedString>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
};

/** A collection of exams (course unit realisations) organised at the same time in one or more locations. */
export type MassExamSession = {
  __typename?: 'MassExamSession';
  courseUnitRealisations?: Maybe<Array<CourseUnitRealisation>>;
  documentState: Scalars['String'];
  duration: Scalars['String'];
  enrolmentAdditionalCancellationEnd?: Maybe<Scalars['String']>;
  enrolmentPeriod?: Maybe<DatePeriod>;
  enrolmentRequirements?: Maybe<Array<PersonRule>>;
  enrolments?: Maybe<Array<Enrolment>>;
  id: Scalars['ID'];
  locationIds?: Maybe<Array<Scalars['ID']>>;
  manualConfirmation: Scalars['Boolean'];
  name: LocalizedString;
  organisations: OrganisationShare;
  publishedById: Scalars['ID'];
  publishedOn: Scalars['String'];
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  startTime: Scalars['String'];
  universityOrgIds: Array<Scalars['ID']>;
  universityOrgs: Array<Organisation>;
};

export type Metadata = {
  __typename?: 'Metadata';
  createdBy?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedOn?: Maybe<Scalars['String']>;
  modificationOrdinal?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

export type MobilityPeriod = {
  __typename?: 'MobilityPeriod';
  activityPeriod?: Maybe<DatePeriod>;
  country?: Maybe<CountryCode>;
  countryCode?: Maybe<CountryCode>;
  countryCodeCanonized?: Maybe<CountryCode>;
  countryUrn?: Maybe<Scalars['String']>;
  documentState: Scalars['String'];
  id: Scalars['ID'];
  isCancelled?: Maybe<Scalars['Boolean']>;
  mobilityDirection: Scalars['String'];
  mobilityProgramUrn?: Maybe<Scalars['String']>;
  mobilityStudyRightTypeUrn?: Maybe<Scalars['String']>;
  mobilityTypeUrn?: Maybe<Scalars['String']>;
  personId: Scalars['ID'];
  phase?: Maybe<Scalars['String']>;
  studyRight?: Maybe<StudyRight>;
  studyRightId: Scalars['ID'];
  virtualMobilityType?: Maybe<Scalars['String']>;
};

export type Module = {
  __typename?: 'Module';
  abbreviation?: Maybe<Scalars['String']>;
  abbreviationAsMarkupString?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<LocalizedMarkupString>;
  approvalState?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeAsMarkupString?: Maybe<Scalars['String']>;
  contentDescription?: Maybe<LocalizedMarkupString>;
  curriculumPeriodIds?: Maybe<Array<Scalars['ID']>>;
  curriculumPeriods?: Maybe<Array<CurriculumPeriod>>;
  customCodeUrns?: Maybe<Array<Scalars['String']>>;
  degreeProgrammeType?: Maybe<Code>;
  degreeProgrammeTypeUrn?: Maybe<Scalars['String']>;
  documentState: Scalars['String'];
  educationLocationUrns?: Maybe<Array<Scalars['String']>>;
  educationLocations?: Maybe<Array<Code>>;
  gradeScale?: Maybe<GradeScale>;
  gradeScaleId?: Maybe<Scalars['ID']>;
  graded?: Maybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  inclusionApplicationInstruction?: Maybe<LocalizedMarkupString>;
  moduleContentApprovalRequired: Scalars['Boolean'];
  name?: Maybe<LocalizedString>;
  organisations?: Maybe<Array<OrganisationShare>>;
  outcomes?: Maybe<LocalizedMarkupString>;
  possibleAttainmentLanguageUrns?: Maybe<Array<Scalars['String']>>;
  possibleAttainmentLanguages?: Maybe<Array<Code>>;
  prerequisites?: Maybe<LocalizedMarkupString>;
  printName?: Maybe<LocalizedString>;
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  rule?: Maybe<Rule>;
  searchTags?: Maybe<Array<Scalars['String']>>;
  studyFieldUrns?: Maybe<Array<Scalars['String']>>;
  studyFields?: Maybe<Array<Code>>;
  studyLevel?: Maybe<Code>;
  studyLevelUrn?: Maybe<Scalars['String']>;
  targetCredits?: Maybe<CreditRange>;
  tweetText?: Maybe<LocalizedString>;
  type?: Maybe<Scalars['String']>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
  validityPeriod?: Maybe<DatePeriod>;
};

export type ModuleGroup = {
  __typename?: 'ModuleGroup';
  groupId: Scalars['ID'];
  moduleIds: Array<Scalars['String']>;
  modules: Array<Module>;
  targetCredits?: Maybe<CreditRange>;
};

export type ModuleTiming = {
  __typename?: 'ModuleTiming';
  module?: Maybe<Module>;
  moduleGroupId: Scalars['ID'];
  plannedPeriods: Array<StudyPeriodLocator>;
  plannedPeriodsAsStrings: Array<Scalars['String']>;
};


export type ModuleTimingModuleArgs = {
  curriculumPeriodId: Scalars['String'];
  universityOrgId: Scalars['String'];
};

/** Shopping cart for Open University purchases. Includes OpenUniversityCartItems that are purchased or to be purchased. */
export type OpenUniversityCart = {
  __typename?: 'OpenUniversityCart';
  activationCode?: Maybe<Scalars['String']>;
  activationCodeValidUntil?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerFirstName?: Maybe<Scalars['String']>;
  buyerLastName?: Maybe<Scalars['String']>;
  documentState: Scalars['String'];
  id: Scalars['ID'];
  items?: Maybe<Array<OpenUniversityCartItem>>;
  orderNumber?: Maybe<Scalars['String']>;
  priceTotal?: Maybe<Scalars['String']>;
  priceWithoutVat?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  studentId?: Maybe<Scalars['ID']>;
  vatPercent: Scalars['Float'];
  vatTotal?: Maybe<Scalars['String']>;
};

/** Single item in OpenUniversityCart */
export type OpenUniversityCartItem = {
  __typename?: 'OpenUniversityCartItem';
  localId: Scalars['String'];
  openUniversityProduct: OpenUniversityProduct;
  openUniversityProductId: Scalars['ID'];
  price: Scalars['String'];
  state: Scalars['String'];
};

/** Product that is sold through open university. Gives the purchaser a right to enroll to specific course unit realisations. */
export type OpenUniversityProduct = {
  __typename?: 'OpenUniversityProduct';
  cancelledOn?: Maybe<Scalars['String']>;
  codeUrns?: Maybe<Array<Scalars['String']>>;
  collaborationInstitution?: Maybe<CollaborationInstitution>;
  completionMethod?: Maybe<CompletionMethod>;
  completionMethodId: Scalars['ID'];
  courseUnit?: Maybe<CourseUnit>;
  courseUnitId: Scalars['ID'];
  credits: Scalars['Float'];
  description?: Maybe<LocalizedString>;
  documentState: Scalars['String'];
  education?: Maybe<Education>;
  educationId: Scalars['ID'];
  enrolmentConstraints?: Maybe<Array<EnrolmentConstraint>>;
  flowState: Scalars['String'];
  id: Scalars['ID'];
  metadata?: Maybe<Metadata>;
  name: LocalizedString;
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['ID'];
  price: Scalars['String'];
  productCode?: Maybe<OpenUniversityProductCode>;
  productCodeId?: Maybe<Scalars['ID']>;
  publishedOn?: Maybe<Scalars['String']>;
  salesPeriod?: Maybe<DateTimePeriod>;
  soldAmount?: Maybe<OpenUniversityProductSoldAmount>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  validityPeriod?: Maybe<DatePeriod>;
};

/** Open university product code is used for accounting and payment systems. */
export type OpenUniversityProductCode = {
  __typename?: 'OpenUniversityProductCode';
  code: Scalars['String'];
  description?: Maybe<LocalizedString>;
  documentState: Scalars['String'];
  id: Scalars['ID'];
  paymentSystem: Scalars['String'];
  universityOrgId: Scalars['ID'];
};

/** Amount of times open university product has been sold by their id. */
export type OpenUniversityProductSoldAmount = {
  __typename?: 'OpenUniversityProductSoldAmount';
  amountSold?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type Organisation = {
  __typename?: 'Organisation';
  abbreviation?: Maybe<LocalizedString>;
  code?: Maybe<Scalars['String']>;
  codeAsMarkupString?: Maybe<Scalars['String']>;
  documentState?: Maybe<Scalars['String']>;
  educationalInstitution?: Maybe<Code>;
  educationalInstitutionUrn?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<LocalizedString>;
  parent?: Maybe<Organisation>;
  parentId?: Maybe<Scalars['ID']>;
  predecessorIds?: Maybe<Array<Scalars['ID']>>;
  predecessors?: Maybe<Array<Organisation>>;
  universityOrg?: Maybe<Organisation>;
  universityOrgId: Scalars['ID'];
};

export type OrganisationShare = {
  __typename?: 'OrganisationShare';
  educationalInstitution?: Maybe<Code>;
  educationalInstitutionUrn?: Maybe<Scalars['String']>;
  organisation?: Maybe<Organisation>;
  organisationId?: Maybe<Scalars['ID']>;
  roleUrn: Scalars['String'];
  share: Scalars['Float'];
};

/** Payment category information from KORI. Descripts the payment type. */
export type PaymentCategory = {
  __typename?: 'PaymentCategory';
  code: Scalars['String'];
  description?: Maybe<LocalizedString>;
  id: Scalars['ID'];
  isHealthCareFee: Scalars['Boolean'];
  isStudentUnionMembershipFee: Scalars['Boolean'];
  universityOrgId: Scalars['String'];
};

export type PersonGroup = {
  __typename?: 'PersonGroup';
  description?: Maybe<LocalizedString>;
  membershipCheckTime?: Maybe<Scalars['String']>;
  membershipUpdateTime?: Maybe<Scalars['String']>;
  name: LocalizedString;
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  type: Scalars['String'];
  updateType?: Maybe<Scalars['String']>;
};

/** Person information from ORI. Contains basic information and requires less privileges than PrivatePerson. */
export type PersonInfo = {
  __typename?: 'PersonInfo';
  callName?: Maybe<Scalars['String']>;
  callNameAsMarkupString?: Maybe<Scalars['String']>;
  firstNames?: Maybe<Scalars['String']>;
  firstNamesAsMarkupString?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  lastNameAsMarkupString?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<Scalars['String']>;
  primaryEmailAsMarkupString?: Maybe<Scalars['String']>;
  studentNumber?: Maybe<Scalars['String']>;
  studentNumberAsMarkupString?: Maybe<Scalars['String']>;
};

export type PersonRule = {
  __typename?: 'PersonRule';
  courseUnitRealisationIds?: Maybe<Array<Scalars['ID']>>;
  courseUnitRealisations?: Maybe<Array<CourseUnitRealisation>>;
  creditRange?: Maybe<CreditRange>;
  degreeProgramType?: Maybe<Code>;
  degreeProgramTypeUrn?: Maybe<Scalars['String']>;
  educationIds?: Maybe<Array<Scalars['ID']>>;
  educations?: Maybe<Array<Education>>;
  personGroupIds?: Maybe<Array<Scalars['ID']>>;
  personGroups?: Maybe<Array<PersonGroup>>;
  type: Scalars['String'];
};

export type PersonWithAttainmentAcceptorType = {
  __typename?: 'PersonWithAttainmentAcceptorType';
  person?: Maybe<PublicPerson>;
  personId?: Maybe<Scalars['String']>;
  roleCode: Code;
  roleUrn: Scalars['String'];
  text?: Maybe<LocalizedString>;
  title?: Maybe<LocalizedString>;
};

export type PersonalizedPhase = {
  __typename?: 'PersonalizedPhase';
  childNaming?: Maybe<Code>;
  childNamingUrn?: Maybe<Scalars['String']>;
};

export type PersonalizedSelectionPath = {
  __typename?: 'PersonalizedSelectionPath';
  phase1?: Maybe<PersonalizedPhase>;
  phase2?: Maybe<PersonalizedPhase>;
};

export type Prerequisite = {
  __typename?: 'Prerequisite';
  courseUnitGroupId?: Maybe<Scalars['ID']>;
  courseUnits?: Maybe<Array<CourseUnit>>;
  moduleGroupId?: Maybe<Scalars['ID']>;
  modules?: Maybe<Array<Module>>;
  type: Scalars['String'];
};


export type PrerequisiteCourseUnitsArgs = {
  universityOrgId: Scalars['ID'];
};


export type PrerequisiteModulesArgs = {
  universityOrgId: Scalars['ID'];
};

export type PrerequisiteGroup = {
  __typename?: 'PrerequisiteGroup';
  prerequisites?: Maybe<Array<Prerequisite>>;
};

/** Private person from ORI. Contains more information than PersonInfo and requires additional privileges. */
export type PrivatePerson = {
  __typename?: 'PrivatePerson';
  attainedQualifications?: Maybe<Array<AttainedQualification>>;
  attainments?: Maybe<Array<Attainment>>;
  attainmentsGradeNumericalAverage?: Maybe<Scalars['Float']>;
  callName?: Maybe<Scalars['String']>;
  callNameAsMarkupString?: Maybe<Scalars['String']>;
  citizenshipUrns?: Maybe<Array<Scalars['String']>>;
  citizenships?: Maybe<Array<CountryCode>>;
  citizenshipsCanonized?: Maybe<Array<CountryCode>>;
  dateOfBirth?: Maybe<Scalars['String']>;
  dead?: Maybe<Scalars['Boolean']>;
  documentState?: Maybe<Scalars['String']>;
  eduPersonPrincipalName?: Maybe<Scalars['String']>;
  eduPersonPrincipalNameAsMarkupString?: Maybe<Scalars['String']>;
  employeeNumber?: Maybe<Scalars['String']>;
  employeeNumberAsMarkupString?: Maybe<Scalars['String']>;
  employeeStatus?: Maybe<EmployeeStatus>;
  enrolments?: Maybe<Array<Enrolment>>;
  firstNames?: Maybe<Scalars['String']>;
  firstNamesAsMarkupString?: Maybe<Scalars['String']>;
  gender?: Maybe<Code>;
  genderUrn?: Maybe<Scalars['String']>;
  grants?: Maybe<Array<Grant>>;
  id: Scalars['ID'];
  identityConfirmed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastNameAsMarkupString?: Maybe<Scalars['String']>;
  motherTongue?: Maybe<Code>;
  motherTongueCanonizedUrn?: Maybe<Scalars['String']>;
  motherTongueUrn?: Maybe<Scalars['String']>;
  municipality?: Maybe<Code>;
  municipalityCanonizedUrn?: Maybe<Scalars['String']>;
  municipalityUrn?: Maybe<Scalars['String']>;
  oids?: Maybe<Array<Scalars['String']>>;
  oppijanumero?: Maybe<Scalars['String']>;
  personalIdentityCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberAsMarkupString?: Maybe<Scalars['String']>;
  preferredLanguage?: Maybe<Code>;
  preferredLanguageUrn?: Maybe<Scalars['String']>;
  primaryAddress?: Maybe<Address>;
  primaryEmail?: Maybe<Scalars['String']>;
  primaryEmailAsMarkupString?: Maybe<Scalars['String']>;
  schoolEducationLanguage?: Maybe<Code>;
  schoolEducationLanguageUrn?: Maybe<Scalars['String']>;
  secondaryAddress?: Maybe<Address>;
  secondaryEmail?: Maybe<Scalars['String']>;
  secondaryEmailAsMarkupString?: Maybe<Scalars['String']>;
  studentNumber?: Maybe<Scalars['String']>;
  studentNumberAsMarkupString?: Maybe<Scalars['String']>;
  studentStatus?: Maybe<StudentStatus>;
  studyEventsInCalendar?: Maybe<Array<EnrolmentWithStudyEvents>>;
  studyRightPrimalityChain?: Maybe<StudyRightPrimalityChain>;
  studyRights?: Maybe<Array<StudyRight>>;
  studyStartDate?: Maybe<Scalars['String']>;
  theses?: Maybe<Array<Thesis>>;
  universityTermRegistrations?: Maybe<Array<UniversityTermRegistration>>;
  userName?: Maybe<Scalars['String']>;
  userNameAsMarkupString?: Maybe<Scalars['String']>;
};


/** Private person from ORI. Contains more information than PersonInfo and requires additional privileges. */
export type PrivatePersonAttainmentsArgs = {
  attainmentTypes?: InputMaybe<Array<Scalars['String']>>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  studyRightId?: InputMaybe<Scalars['ID']>;
};


/** Private person from ORI. Contains more information than PersonInfo and requires additional privileges. */
export type PrivatePersonAttainmentsGradeNumericalAverageArgs = {
  studyRightId?: InputMaybe<Scalars['ID']>;
};


/** Private person from ORI. Contains more information than PersonInfo and requires additional privileges. */
export type PrivatePersonEnrolmentsArgs = {
  activityStatus?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Scalars['String']>>;
};


/** Private person from ORI. Contains more information than PersonInfo and requires additional privileges. */
export type PrivatePersonStudyEventsInCalendarArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  studySubGroupFilter?: InputMaybe<Scalars['String']>;
};


/** Private person from ORI. Contains more information than PersonInfo and requires additional privileges. */
export type PrivatePersonStudyRightsArgs = {
  state?: InputMaybe<Scalars['String']>;
};


/** Private person from ORI. Contains more information than PersonInfo and requires additional privileges. */
export type PrivatePersonUniversityTermRegistrationsArgs = {
  universityOrgId: Scalars['ID'];
};

/** Private person basic info from ORI. The minimal set of personal data that is shown for example for teachers. */
export type PrivatePersonBasicInfo = {
  __typename?: 'PrivatePersonBasicInfo';
  callName?: Maybe<Scalars['String']>;
  callNameAsMarkupString?: Maybe<Scalars['String']>;
  firstNames?: Maybe<Scalars['String']>;
  firstNamesAsMarkupString?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPhoneNumberClassified?: Maybe<Scalars['Boolean']>;
  isSecondaryEmailClassified?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastNameAsMarkupString?: Maybe<Scalars['String']>;
  oppijanumero?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberAsMarkupString?: Maybe<Scalars['String']>;
  preferredLanguage?: Maybe<Code>;
  preferredLanguageUrn?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<Scalars['String']>;
  primaryEmailAsMarkupString?: Maybe<Scalars['String']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  secondaryEmailAsMarkupString?: Maybe<Scalars['String']>;
  studentNumber?: Maybe<Scalars['String']>;
  studentNumberAsMarkupString?: Maybe<Scalars['String']>;
};

export type PublicPerson = {
  __typename?: 'PublicPerson';
  emailAddress?: Maybe<Scalars['String']>;
  emailAddressAsMarkupString?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstNameAsMarkupString?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  lastNameAsMarkupString?: Maybe<Scalars['String']>;
  titles?: Maybe<Array<LocalizedString>>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
};

export type Qualification = {
  __typename?: 'Qualification';
  code: Scalars['String'];
  codeAsMarkupString: Scalars['String'];
  competencyUrn?: Maybe<Scalars['String']>;
  customQualificationTypeUrn?: Maybe<Scalars['String']>;
  diplomaAppendix?: Maybe<LocalizedString>;
  id: Scalars['ID'];
  includeCompetencies?: Maybe<Scalars['Boolean']>;
  instructions?: Maybe<LocalizedString>;
  name: LocalizedString;
  printName?: Maybe<LocalizedString>;
  publishedOn: Scalars['String'];
  qualificationUrn?: Maybe<Scalars['String']>;
  requirementCollections?: Maybe<Array<RequirementCollection>>;
  state: Scalars['String'];
  type: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  assessment_item_ids_by_ordinal: ExportResult;
  assessment_items: Array<AssessmentItem>;
  attained_qualification: AttainedQualification;
  attained_qualification_ids_by_ordinal: ExportResult;
  attained_qualifications: Array<AttainedQualification>;
  attainment: Attainment;
  attainment_ids_by_ordinal: AttainmentExportResult;
  attainments: Array<Attainment>;
  authenticated_course_unit_realisation_search: Array<CourseUnitRealisation>;
  authenticated_course_unit_search: Array<CourseUnit>;
  authenticated_degree_programme_search: Array<DegreeProgramme>;
  authenticated_education_search: Array<Education>;
  authenticated_study_module_search: Array<StudyModule>;
  code: Code;
  codes: Array<Code>;
  course_unit: CourseUnit;
  course_unit_ids_by_ordinal: ExportResult;
  course_unit_realisation: CourseUnitRealisation;
  course_unit_realisation_search: Array<CourseUnitRealisation>;
  course_unit_realisations: Array<CourseUnitRealisation>;
  course_unit_realisations_by_assessment_item: Array<CourseUnitRealisation>;
  course_unit_realisations_by_mass_exam_session: Array<CourseUnitRealisation>;
  course_unit_realisations_for_teacher: Array<CourseUnitRealisation>;
  course_unit_search: Array<CourseUnit>;
  course_units: Array<CourseUnit>;
  course_units_by_assessment_item: Array<CourseUnit>;
  course_units_by_group_id: Array<CourseUnit>;
  curriculumPeriods: Array<CurriculumPeriod>;
  curriculum_period: CurriculumPeriod;
  degreeProgramme: DegreeProgramme;
  degree_programme_search: Array<DegreeProgramme>;
  education: Education;
  education_ids_by_ordinal: ExportResult;
  education_search: Array<Education>;
  educations: Array<Education>;
  electronic_signature_image: ElectronicSignatureImage;
  employees: Array<PrivatePerson>;
  enrolment_right: EnrolmentRight;
  enrolment_right_ids_by_ordinal: ExportResult;
  enrolment_rights: Array<EnrolmentRight>;
  enrolments_by_mass_exam_session: Array<Enrolment>;
  find_open_university_study_right_ids_of_attainments_changed_since_ordinal: ExportResult;
  find_students_whose_payments_have_changed_since_ordinal: ExportResult;
  find_students_whose_primalities_have_changed_since_ordinal: ExportResult;
  find_study_right_ids_of_enrolment_rights_changed_since_ordinal: ExportResult;
  find_study_right_ids_of_grants_changed_since_ordinal: ExportResult;
  find_study_rights_whose_tuition_fee_obligation_periods_have_changed_since_ordinal: ExportResult;
  get_all_own_hidden_teachings: Array<HiddenTeaching>;
  grade_scales: Array<GradeScale>;
  graduation: Graduation;
  grants_by_person_id: Array<Grant>;
  grants_by_study_right_id: Array<Grant>;
  internationalContractualDegreeAgreement: InternationalContractualDegreeAgreement;
  mass_exam_session: MassExamSession;
  mobility_period_ids_by_ordinal: ExportResult;
  mobility_periods: Array<MobilityPeriod>;
  module: Module;
  module_ids_by_ordinal: ExportResult;
  modules: Array<Module>;
  modules_by_group_id: Array<Module>;
  modules_by_ids: Array<Module>;
  open_university_cart: OpenUniversityCart;
  open_university_product: OpenUniversityProduct;
  organisation: Organisation;
  organisation_ids_by_ordinal: ExportResult;
  organisations: Array<Organisation>;
  payment_category: PaymentCategory;
  private_person: PrivatePerson;
  private_person_by_edu_person_principal_name: PrivatePerson;
  private_person_by_employee_number: PrivatePerson;
  private_person_by_oid: PrivatePerson;
  private_person_by_oppija_id: PrivatePerson;
  private_person_by_oppijanumero: PrivatePerson;
  private_person_by_personal_identity_code: PrivatePerson;
  private_person_by_student_number: PrivatePerson;
  private_persons: Array<PrivatePerson>;
  public_person: PublicPerson;
  public_persons: Array<PublicPerson>;
  reference_ids_by_student_ids: StudentReferenceData;
  search_course_unit_realisations_for_teacher: CourseUnitRealisationTeacherSearchResult;
  student_ids_by_ordinal: ExportResult;
  student_payments: Array<StudentPayment>;
  student_payments_of_term: Array<StudentPayment>;
  students: Array<PrivatePerson>;
  studyModule: StudyModule;
  study_event: StudyEvent;
  study_module_search: Array<StudyModule>;
  study_right: StudyRight;
  study_right_current_ids_by_ordinal: ExportIdResult;
  study_right_primality_chain_for_person: StudyRightPrimalityChain;
  study_right_primality_chains_for_persons: Array<StudyRightPrimalityChain>;
  study_right_snapshot: StudyRight;
  study_right_snapshot_ids_by_ordinal: ExportResult;
  study_right_snapshots: Array<StudyRight>;
  study_right_student_ids_by_ordinal: ExportIdResult;
  study_right_term_registrations: Array<StudyRightTermRegistrations>;
  study_rights: Array<StudyRight>;
  study_term: StudyTerm;
  term_registration_requirements: TermRegistrationRequirements;
  term_registration_study_right_ids_by_ordinal: ExportResult;
  term_registrations: Array<TermRegistration>;
  tuition_fee_obligation_periods_for_study_right: Array<TuitionFeeObligationPeriod>;
};


export type QueryAssessment_Item_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryAssessment_ItemsArgs = {
  assessmentItemIds: Array<Scalars['ID']>;
};


export type QueryAttained_QualificationArgs = {
  id: Scalars['ID'];
};


export type QueryAttained_Qualification_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryAttained_QualificationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryAttainmentArgs = {
  id: Scalars['ID'];
};


export type QueryAttainment_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
  sinceThesis: Scalars['Float'];
};


export type QueryAttainmentsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryAuthenticated_Course_Unit_Realisation_SearchArgs = {
  activityPeriods?: InputMaybe<Array<DatePeriodInput>>;
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  cooperationNetworkIds?: InputMaybe<Array<Scalars['ID']>>;
  cooperationNetworkIdsForUniversityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  flowStates?: InputMaybe<Array<Scalars['String']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  orgIds?: InputMaybe<Array<Scalars['ID']>>;
  responsiblePersonIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Float']>;
  uiLang?: InputMaybe<Scalars['String']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validityInCooperationNetwork?: InputMaybe<SearchValidity>;
};


export type QueryAuthenticated_Course_Unit_SearchArgs = {
  codeQuery?: InputMaybe<Scalars['String']>;
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  cooperationNetworkIds?: InputMaybe<Array<Scalars['ID']>>;
  cooperationNetworkIdsForUniversityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  cooperationNetworkSearchType?: InputMaybe<CooperationNetworkSearchType>;
  courseUnitRealisationActivityPeriods?: InputMaybe<Array<DatePeriodInput>>;
  courseUnitRealisationActivityStatus?: InputMaybe<Scalars['String']>;
  curriculumPeriodIds?: InputMaybe<Array<Scalars['ID']>>;
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<Scalars['ID']>>;
  responsiblePersonIds?: InputMaybe<Array<Scalars['ID']>>;
  resultLimit?: InputMaybe<Scalars['Int']>;
  resultSort?: InputMaybe<Scalars['String']>;
  resultStart?: InputMaybe<Scalars['Int']>;
  returnAllGroupVersions?: InputMaybe<Scalars['Boolean']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validity?: InputMaybe<Scalars['String']>;
  validityInCooperationNetwork?: InputMaybe<SearchValidity>;
};


export type QueryAuthenticated_Degree_Programme_SearchArgs = {
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  curriculumPeriodIds?: InputMaybe<Array<Scalars['ID']>>;
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  orgIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Float']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validity?: InputMaybe<Scalars['String']>;
};


export type QueryAuthenticated_Education_SearchArgs = {
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  educationTypeUrns?: InputMaybe<Array<Scalars['String']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  responsibleOrganisationIds?: InputMaybe<Array<Scalars['ID']>>;
  resultLimit?: InputMaybe<Scalars['Int']>;
  resultSort?: InputMaybe<Scalars['String']>;
  resultStart?: InputMaybe<Scalars['Int']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validityDates?: InputMaybe<Array<DatePeriodInput>>;
};


export type QueryAuthenticated_Study_Module_SearchArgs = {
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  curriculumPeriodIds?: InputMaybe<Array<Scalars['ID']>>;
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orgIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validity?: InputMaybe<Scalars['String']>;
};


export type QueryCodeArgs = {
  urn: Scalars['String'];
};


export type QueryCodesArgs = {
  urns: Array<Scalars['String']>;
};


export type QueryCourse_UnitArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCourse_Unit_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryCourse_Unit_RealisationArgs = {
  id: Scalars['ID'];
};


export type QueryCourse_Unit_Realisation_SearchArgs = {
  activityPeriods?: InputMaybe<Array<DatePeriodInput>>;
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  cooperationNetworkIds?: InputMaybe<Array<Scalars['ID']>>;
  cooperationNetworkIdsForUniversityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  flowStates?: InputMaybe<Array<Scalars['String']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  orgIds?: InputMaybe<Array<Scalars['ID']>>;
  responsiblePersonIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Float']>;
  uiLang?: InputMaybe<Scalars['String']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validityInCooperationNetwork?: InputMaybe<SearchValidity>;
};


export type QueryCourse_Unit_RealisationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCourse_Unit_Realisations_By_Assessment_ItemArgs = {
  activityStatus?: InputMaybe<Scalars['String']>;
  assessmentItemId: Scalars['ID'];
  flowStates?: InputMaybe<Scalars['String']>;
};


export type QueryCourse_Unit_Realisations_By_Mass_Exam_SessionArgs = {
  massExamSessionId: Scalars['ID'];
};


export type QueryCourse_Unit_Realisations_For_TeacherArgs = {
  activityStatus: Scalars['String'];
};


export type QueryCourse_Unit_SearchArgs = {
  codeQuery?: InputMaybe<Scalars['String']>;
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  cooperationNetworkIds?: InputMaybe<Array<Scalars['ID']>>;
  cooperationNetworkIdsForUniversityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  cooperationNetworkSearchType?: InputMaybe<CooperationNetworkSearchType>;
  courseUnitRealisationActivityPeriods?: InputMaybe<Array<DatePeriodInput>>;
  courseUnitRealisationActivityStatus?: InputMaybe<Scalars['String']>;
  curriculumPeriodIds?: InputMaybe<Array<Scalars['ID']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<Scalars['ID']>>;
  responsiblePersonIds?: InputMaybe<Array<Scalars['ID']>>;
  resultLimit?: InputMaybe<Scalars['Int']>;
  resultSort?: InputMaybe<Scalars['String']>;
  resultStart?: InputMaybe<Scalars['Int']>;
  returnAllGroupVersions?: InputMaybe<Scalars['Boolean']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validity?: InputMaybe<Scalars['String']>;
  validityInCooperationNetwork?: InputMaybe<SearchValidity>;
};


export type QueryCourse_UnitsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCourse_Units_By_Assessment_ItemArgs = {
  assessmentItemId: Scalars['ID'];
};


export type QueryCourse_Units_By_Group_IdArgs = {
  curriculumPeriodId?: InputMaybe<Scalars['ID']>;
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  groupIds: Array<Scalars['ID']>;
  universityId: Scalars['ID'];
};


export type QueryCurriculumPeriodsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCurriculum_PeriodArgs = {
  date: Scalars['String'];
  universityOrgId: Scalars['ID'];
};


export type QueryDegreeProgrammeArgs = {
  degreeProgrammeId: Scalars['ID'];
};


export type QueryDegree_Programme_SearchArgs = {
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  curriculumPeriodIds?: InputMaybe<Array<Scalars['ID']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  orgIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Float']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validity?: InputMaybe<Scalars['String']>;
};


export type QueryEducationArgs = {
  id: Scalars['ID'];
};


export type QueryEducation_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryEducation_SearchArgs = {
  educationTypeUrns?: InputMaybe<Array<Scalars['String']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  responsibleOrganisationIds?: InputMaybe<Array<Scalars['ID']>>;
  resultLimit?: InputMaybe<Scalars['Int']>;
  resultSort?: InputMaybe<Scalars['String']>;
  resultStart?: InputMaybe<Scalars['Int']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validityDates?: InputMaybe<Array<DatePeriodInput>>;
};


export type QueryEducationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryElectronic_Signature_ImageArgs = {
  signatureOwnerId: Scalars['ID'];
};


export type QueryEmployeesArgs = {
  employeeNumber?: InputMaybe<Scalars['String']>;
  employeeSearchString?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryEnrolment_RightArgs = {
  id: Scalars['ID'];
};


export type QueryEnrolment_Right_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryEnrolment_RightsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryEnrolments_By_Mass_Exam_SessionArgs = {
  massExamSessionId: Scalars['ID'];
};


export type QueryFind_Open_University_Study_Right_Ids_Of_Attainments_Changed_Since_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryFind_Students_Whose_Payments_Have_Changed_Since_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryFind_Students_Whose_Primalities_Have_Changed_Since_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryFind_Study_Right_Ids_Of_Enrolment_Rights_Changed_Since_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryFind_Study_Right_Ids_Of_Grants_Changed_Since_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryFind_Study_Rights_Whose_Tuition_Fee_Obligation_Periods_Have_Changed_Since_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryGraduationArgs = {
  id: Scalars['ID'];
};


export type QueryGrants_By_Person_IdArgs = {
  personId: Scalars['ID'];
};


export type QueryGrants_By_Study_Right_IdArgs = {
  studyRightId: Scalars['ID'];
};


export type QueryInternationalContractualDegreeAgreementArgs = {
  id: Scalars['ID'];
};


export type QueryMass_Exam_SessionArgs = {
  id: Scalars['ID'];
};


export type QueryMobility_Period_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryMobility_PeriodsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryModuleArgs = {
  id: Scalars['ID'];
};


export type QueryModule_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryModulesArgs = {
  curriculumPeriodId: Scalars['ID'];
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  groupIds: Array<Scalars['ID']>;
  preferByState?: InputMaybe<Scalars['Boolean']>;
  universityOrgId: Scalars['ID'];
};


export type QueryModules_By_Group_IdArgs = {
  curriculumPeriodId?: InputMaybe<Scalars['ID']>;
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  groupIds: Array<Scalars['ID']>;
  universityId: Scalars['ID'];
};


export type QueryModules_By_IdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryOpen_University_CartArgs = {
  id: Scalars['ID'];
};


export type QueryOpen_University_ProductArgs = {
  id: Scalars['ID'];
};


export type QueryOrganisationArgs = {
  id: Scalars['ID'];
};


export type QueryOrganisation_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryOrganisationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPayment_CategoryArgs = {
  categoryId: Scalars['ID'];
};


export type QueryPrivate_PersonArgs = {
  id: Scalars['ID'];
};


export type QueryPrivate_Person_By_Edu_Person_Principal_NameArgs = {
  id: Scalars['ID'];
};


export type QueryPrivate_Person_By_Employee_NumberArgs = {
  id: Scalars['ID'];
};


export type QueryPrivate_Person_By_OidArgs = {
  oid: Scalars['ID'];
};


export type QueryPrivate_Person_By_Oppija_IdArgs = {
  id: Scalars['ID'];
};


export type QueryPrivate_Person_By_OppijanumeroArgs = {
  oppijanumero: Scalars['ID'];
};


export type QueryPrivate_Person_By_Personal_Identity_CodeArgs = {
  id: Scalars['ID'];
};


export type QueryPrivate_Person_By_Student_NumberArgs = {
  id: Scalars['ID'];
};


export type QueryPrivate_PersonsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryPublic_PersonArgs = {
  id: Scalars['ID'];
};


export type QueryPublic_PersonsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryReference_Ids_By_Student_IdsArgs = {
  studentIds: Array<Scalars['String']>;
};


export type QuerySearch_Course_Unit_Realisations_For_TeacherArgs = {
  activityEnd?: InputMaybe<Scalars['String']>;
  activityStatus?: InputMaybe<Scalars['String']>;
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  continuousEnrolment?: InputMaybe<Scalars['Boolean']>;
  enrolmentOngoing?: InputMaybe<Scalars['Boolean']>;
  evaluationPeriod?: InputMaybe<DatePeriodInput>;
  fetchOnlyHiddenCurs?: InputMaybe<Scalars['Boolean']>;
  flowStates?: InputMaybe<Array<Scalars['String']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  getPastArchivedAndCancelled?: InputMaybe<Scalars['Boolean']>;
  hiddenCurIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  uiLang?: InputMaybe<Scalars['String']>;
};


export type QueryStudent_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryStudent_PaymentsArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudent_Payments_Of_TermArgs = {
  studentId: Scalars['ID'];
  termIndex: Scalars['Float'];
  year: Scalars['Float'];
};


export type QueryStudentsArgs = {
  attendingTermRegistrations?: InputMaybe<Array<Scalars['String']>>;
  citizenshipUrns?: InputMaybe<Array<Scalars['String']>>;
  dead?: InputMaybe<Scalars['Boolean']>;
  educationIds?: InputMaybe<Array<Scalars['String']>>;
  genderUrn?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  learningOpportunities?: InputMaybe<Array<Scalars['String']>>;
  motherTongueUrns?: InputMaybe<Array<Scalars['String']>>;
  municipalityUrns?: InputMaybe<Array<Scalars['String']>>;
  nonAttendingTermRegistrations?: InputMaybe<Array<Scalars['String']>>;
  preferredLanguageUrns?: InputMaybe<Array<Scalars['String']>>;
  schoolEducationLanguageUrns?: InputMaybe<Array<Scalars['String']>>;
  studentNumber?: InputMaybe<Scalars['String']>;
  studyRightExpirationRulesUrns?: InputMaybe<Array<Scalars['String']>>;
  studyRightMinorSelections?: InputMaybe<Array<Scalars['String']>>;
  studyRightOrganisationIds?: InputMaybe<Array<Scalars['String']>>;
  studyRightSelectedChildOptions?: InputMaybe<Array<Scalars['String']>>;
  studyRightSelectedOptions?: InputMaybe<Array<Scalars['String']>>;
  studyRightStates?: InputMaybe<Array<Scalars['String']>>;
  validityPeriod?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryStudyModuleArgs = {
  studyModuleId: Scalars['ID'];
};


export type QueryStudy_EventArgs = {
  id: Scalars['ID'];
};


export type QueryStudy_Module_SearchArgs = {
  codeUrns?: InputMaybe<Array<Scalars['String']>>;
  curriculumPeriodIds?: InputMaybe<Array<Scalars['ID']>>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orgIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  universityOrgIds?: InputMaybe<Array<Scalars['ID']>>;
  validity?: InputMaybe<Scalars['String']>;
};


export type QueryStudy_RightArgs = {
  id: Scalars['ID'];
};


export type QueryStudy_Right_Current_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryStudy_Right_Primality_Chain_For_PersonArgs = {
  id: Scalars['ID'];
};


export type QueryStudy_Right_Primality_Chains_For_PersonsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryStudy_Right_SnapshotArgs = {
  snapshotDateTime: Scalars['String'];
  studyRightId: Scalars['String'];
};


export type QueryStudy_Right_Snapshot_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryStudy_Right_SnapshotsArgs = {
  studyRightId: Scalars['String'];
};


export type QueryStudy_Right_Student_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryStudy_Right_Term_RegistrationsArgs = {
  studyRightIds: Array<Scalars['ID']>;
};


export type QueryStudy_RightsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryStudy_TermArgs = {
  organisationId: Scalars['ID'];
  termIndex: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryTerm_Registration_RequirementsArgs = {
  universityId: Scalars['ID'];
};


export type QueryTerm_Registration_Study_Right_Ids_By_OrdinalArgs = {
  limit: Scalars['Int'];
  since: Scalars['Float'];
};


export type QueryTerm_RegistrationsArgs = {
  studyRightIds: Array<Scalars['ID']>;
};


export type QueryTuition_Fee_Obligation_Periods_For_Study_RightArgs = {
  studyRightId: Scalars['ID'];
};

export type Range = {
  __typename?: 'Range';
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type RequirementCollection = {
  __typename?: 'RequirementCollection';
  courseUnitGroupIds?: Maybe<Array<Scalars['ID']>>;
  degreeProgrammeGroupIds?: Maybe<Array<Scalars['ID']>>;
  description?: Maybe<Scalars['String']>;
  descriptionAsMarkupString?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  studyModuleGroupIds?: Maybe<Array<Scalars['ID']>>;
};

export type ResponsibilityInfo = {
  __typename?: 'ResponsibilityInfo';
  person?: Maybe<PublicPerson>;
  personId?: Maybe<Scalars['ID']>;
  role?: Maybe<Code>;
  roleUrn?: Maybe<Scalars['String']>;
  text?: Maybe<LocalizedString>;
  validityPeriod?: Maybe<DatePeriod>;
};

export type Rule = {
  __typename?: 'Rule';
  allRules?: Maybe<Array<Rule>>;
  courseUnit?: Maybe<CourseUnit>;
  courseUnitGroup?: Maybe<Array<CourseUnit>>;
  courseUnitGroupId?: Maybe<Scalars['ID']>;
  credits?: Maybe<CreditRange>;
  module?: Maybe<Module>;
  moduleGroup?: Maybe<Array<Module>>;
  moduleGroupId?: Maybe<Scalars['ID']>;
  require?: Maybe<Range>;
  /** @deprecated Single rule and rules are copied to the allRules array */
  rule?: Maybe<Rule>;
  /** @deprecated Single rule and rules are copied to the allRules array */
  rules?: Maybe<Array<Rule>>;
  type: Scalars['String'];
};


export type RuleCourseUnitArgs = {
  curriculumPeriodId: Scalars['ID'];
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  preferByState?: InputMaybe<Scalars['Boolean']>;
  universityOrgId: Scalars['ID'];
};


export type RuleCourseUnitGroupArgs = {
  universityOrgId: Scalars['ID'];
};


export type RuleModuleArgs = {
  curriculumPeriodId: Scalars['ID'];
  documentStates?: InputMaybe<Array<Scalars['String']>>;
  preferByState?: InputMaybe<Scalars['Boolean']>;
  universityOrgId: Scalars['ID'];
};


export type RuleModuleGroupArgs = {
  universityOrgId?: InputMaybe<Scalars['ID']>;
};

export enum SearchValidity {
  All = 'ALL',
  Future = 'FUTURE',
  Ongoing = 'ONGOING',
  OngoingAndFuture = 'ONGOING_AND_FUTURE',
  Past = 'PAST'
}

export type SelectionPath = {
  __typename?: 'SelectionPath';
  educationPhase1?: Maybe<Module>;
  educationPhase1Child?: Maybe<Module>;
  educationPhase1ChildGroupId?: Maybe<Scalars['ID']>;
  educationPhase1ChildModuleGroup?: Maybe<ModuleGroup>;
  educationPhase1GroupId?: Maybe<Scalars['ID']>;
  educationPhase1ModuleGroup?: Maybe<ModuleGroup>;
  educationPhase2?: Maybe<Module>;
  educationPhase2Child?: Maybe<Module>;
  educationPhase2ChildGroupId?: Maybe<Scalars['ID']>;
  educationPhase2ChildModuleGroup?: Maybe<ModuleGroup>;
  educationPhase2GroupId?: Maybe<Scalars['ID']>;
  educationPhase2ModuleGroup?: Maybe<ModuleGroup>;
  universityOrgId?: Maybe<Scalars['ID']>;
};

export type Signatory = {
  __typename?: 'Signatory';
  person?: Maybe<PublicPerson>;
  personId: Scalars['ID'];
  title: LocalizedString;
};

export type StoredDocument = {
  __typename?: 'StoredDocument';
  completionTime?: Maybe<Scalars['String']>;
  contentUrl?: Maybe<Scalars['String']>;
  documentType: Scalars['String'];
  draft?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  generationParameters?: Maybe<Scalars['String']>;
  graduationId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  hasElectronicSignatures: Scalars['Boolean'];
  id: Scalars['ID'];
  requestUserId: Scalars['ID'];
  startTime: Scalars['String'];
  subjectUserId?: Maybe<Scalars['ID']>;
  ticketId: Scalars['ID'];
};

export type StudentPayment = {
  __typename?: 'StudentPayment';
  documentState: Scalars['String'];
  id: Scalars['ID'];
  invalidated: Scalars['Boolean'];
  invalidationRationale?: Maybe<Scalars['String']>;
  paymentAmount: Scalars['Float'];
  paymentCategory?: Maybe<PaymentCategory>;
  paymentCategoryId?: Maybe<Scalars['String']>;
  paymentDate?: Maybe<Scalars['String']>;
  registeredBy?: Maybe<Scalars['String']>;
  registrationDate: Scalars['String'];
  source: Scalars['String'];
  studentId: Scalars['ID'];
  studyTerm?: Maybe<StudyTermLocator>;
  type: StudentPaymentType;
};

export enum StudentPaymentType {
  OiliPayment = 'OILI_PAYMENT',
  TuitionFeePayment = 'TUITION_FEE_PAYMENT'
}

/** Used by SISU-VIRTA to collect ids belonging to students */
export type StudentReferenceData = {
  __typename?: 'StudentReferenceData';
  attainedQualificationIds: Array<Scalars['String']>;
  attainmentIds: Array<Scalars['String']>;
  mobilityPeriodIds: Array<Scalars['String']>;
  studentIds: Array<Scalars['String']>;
  studyRightIds: Array<Scalars['String']>;
};

export enum StudentStatus {
  Active = 'ACTIVE',
  None = 'NONE'
}

export type StudyEvent = {
  __typename?: 'StudyEvent';
  cancellations?: Maybe<Array<Scalars['String']>>;
  documentState: Scalars['String'];
  duration?: Maybe<Scalars['String']>;
  events?: Maybe<Array<StudyEventRealisation>>;
  exceptions?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  locationIds?: Maybe<Array<Scalars['ID']>>;
  locations?: Maybe<Array<Location>>;
  name?: Maybe<LocalizedString>;
  overrides?: Maybe<Array<EventOverride>>;
  primaryCourseUnitRealisationId: Scalars['ID'];
  recursEvery?: Maybe<Scalars['String']>;
  recursUntil?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
};

export type StudyEventRealisation = {
  __typename?: 'StudyEventRealisation';
  cancelled: Scalars['Boolean'];
  duration?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  excluded: Scalars['Boolean'];
  start?: Maybe<Scalars['String']>;
};

export type StudyGroupSet = {
  __typename?: 'StudyGroupSet';
  localId: Scalars['ID'];
  name?: Maybe<LocalizedString>;
  studySubGroups?: Maybe<Array<StudySubGroup>>;
  subGroupRange?: Maybe<Range>;
};


export type StudyGroupSetStudySubGroupsArgs = {
  removeCancelled?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type StudyModule = {
  __typename?: 'StudyModule';
  abbreviation?: Maybe<Scalars['String']>;
  abbreviationAsMarkupString?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<LocalizedMarkupString>;
  approvalState?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeAsMarkupString?: Maybe<Scalars['String']>;
  contentDescription?: Maybe<LocalizedMarkupString>;
  contentFilter?: Maybe<ContentFilter>;
  curriculumPeriodIds?: Maybe<Array<Scalars['ID']>>;
  curriculumPeriods?: Maybe<Array<CurriculumPeriod>>;
  customCodeUrns?: Maybe<Array<Scalars['String']>>;
  customCodes?: Maybe<Array<Code>>;
  documentState: Scalars['String'];
  gradeScale?: Maybe<GradeScale>;
  gradeScaleId?: Maybe<Scalars['ID']>;
  graded: Scalars['Boolean'];
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  inclusionApplicationInstruction?: Maybe<LocalizedMarkupString>;
  minorStudyRightAcceptanceType?: Maybe<Code>;
  minorStudyRightAcceptanceTypeUrn?: Maybe<Scalars['String']>;
  minorStudyRightApplicationInstructions?: Maybe<LocalizedMarkupString>;
  moduleContentApprovalRequired: Scalars['Boolean'];
  name?: Maybe<LocalizedString>;
  organisations?: Maybe<Array<OrganisationShare>>;
  outcomes?: Maybe<LocalizedMarkupString>;
  possibleAttainmentLanguageUrns?: Maybe<Array<Scalars['String']>>;
  possibleAttainmentLanguages?: Maybe<Array<Code>>;
  prerequisites?: Maybe<LocalizedMarkupString>;
  responsibilityInfos?: Maybe<Array<ResponsibilityInfo>>;
  rule?: Maybe<Rule>;
  searchTags?: Maybe<Array<Scalars['String']>>;
  studyFieldUrns?: Maybe<Array<Scalars['String']>>;
  studyFields?: Maybe<Array<Code>>;
  studyLevel?: Maybe<Code>;
  studyLevelUrn?: Maybe<Scalars['String']>;
  studyRightSelectionType?: Maybe<Code>;
  studyRightSelectionTypeUrn?: Maybe<Scalars['String']>;
  substitutions?: Maybe<LocalizedMarkupString>;
  targetCredits?: Maybe<CreditRange>;
  tweetText?: Maybe<LocalizedString>;
  type?: Maybe<Scalars['String']>;
  universityOrgIds?: Maybe<Array<Scalars['ID']>>;
  universityOrgs?: Maybe<Array<Organisation>>;
  validityPeriod?: Maybe<DatePeriod>;
};

export type StudyPeriod = {
  __typename?: 'StudyPeriod';
  includedInTargetCreditsCalculation: Scalars['Boolean'];
  name: LocalizedString;
  size: Scalars['Int'];
  valid: DatePeriod;
  visibleByDefault: Scalars['Boolean'];
};

export type StudyPeriodLocator = {
  __typename?: 'StudyPeriodLocator';
  objectString?: Maybe<Scalars['String']>;
  organisationId?: Maybe<Scalars['ID']>;
  periodIndex?: Maybe<Scalars['Int']>;
  studyPeriod?: Maybe<StudyPeriod>;
  studyTerm?: Maybe<StudyTerm>;
  termIndex?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type StudyPeriodTemplateLocator = {
  __typename?: 'StudyPeriodTemplateLocator';
  firstYear?: Maybe<Scalars['Int']>;
  organisationId?: Maybe<Scalars['ID']>;
  periodIndex?: Maybe<Scalars['Int']>;
  studyPeriod?: Maybe<StudyPeriod>;
  studyTerm?: Maybe<StudyTerm>;
  termIndex?: Maybe<Scalars['Int']>;
};

export type StudyRight = {
  __typename?: 'StudyRight';
  acceptedSelectionPath?: Maybe<SelectionPath>;
  activePhaseModule?: Maybe<Module>;
  activePhaseModuleGroupId?: Maybe<Scalars['ID']>;
  admissionType?: Maybe<Code>;
  admissionTypeUrn?: Maybe<Scalars['String']>;
  attainedQualifications?: Maybe<Array<AttainedQualification>>;
  courseUnitSelections?: Maybe<Array<StudyRightCourseUnitSelection>>;
  decreeOnUniversityDegrees?: Maybe<Code>;
  decreeOnUniversityDegreesUrn?: Maybe<Scalars['String']>;
  degreeRegulations?: Maybe<Scalars['String']>;
  degreeRegulationsAsMarkupString?: Maybe<Scalars['String']>;
  documentState: Scalars['String'];
  education?: Maybe<Education>;
  educationId?: Maybe<Scalars['ID']>;
  enrolmentRights?: Maybe<Array<EnrolmentRight>>;
  fundingSource?: Maybe<Code>;
  fundingSourceUrn?: Maybe<Scalars['String']>;
  grantDate?: Maybe<Scalars['String']>;
  grants?: Maybe<Array<Grant>>;
  homeOrganisation?: Maybe<Code>;
  homeOrganisationUrn?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  learningOpportunityId?: Maybe<Scalars['ID']>;
  moduleAttainmentInfos?: Maybe<Array<AttainmentInfo>>;
  moduleSelections?: Maybe<Array<StudyRightModuleSelection>>;
  organisation?: Maybe<Organisation>;
  organisationId?: Maybe<Scalars['ID']>;
  personalizedSelectionPath?: Maybe<PersonalizedSelectionPath>;
  phase1EducationClassification?: Maybe<Code>;
  phase1EducationClassificationLocked?: Maybe<Scalars['Boolean']>;
  phase1EducationClassificationUrn?: Maybe<Scalars['String']>;
  phase1EducationLocation?: Maybe<Code>;
  phase1EducationLocationCanonizedUrn?: Maybe<Scalars['String']>;
  phase1EducationLocationUrn?: Maybe<Scalars['String']>;
  phase1InternationalContractualDegree?: Maybe<InternationalContractualDegree>;
  phase1MinorSelections?: Maybe<Array<StudyRightMinorSelection>>;
  phase1QualificationUrns?: Maybe<Array<Scalars['String']>>;
  phase1Qualifications?: Maybe<Array<Code>>;
  phase1StudyRightClassificationUrns?: Maybe<Array<Scalars['String']>>;
  phase1StudyRightClassifications?: Maybe<Array<Code>>;
  phase2EducationClassification?: Maybe<Code>;
  phase2EducationClassificationLocked?: Maybe<Scalars['Boolean']>;
  phase2EducationClassificationUrn?: Maybe<Scalars['String']>;
  phase2EducationLocation?: Maybe<Code>;
  phase2EducationLocationCanonizedUrn?: Maybe<Scalars['String']>;
  phase2EducationLocationUrn?: Maybe<Scalars['String']>;
  phase2InternationalContractualDegree?: Maybe<InternationalContractualDegree>;
  phase2MinorSelections?: Maybe<Array<StudyRightMinorSelection>>;
  phase2QualificationUrns?: Maybe<Array<Scalars['String']>>;
  phase2Qualifications?: Maybe<Array<Code>>;
  phase2StudyRightClassificationUrns?: Maybe<Array<Scalars['String']>>;
  phase2StudyRightClassifications?: Maybe<Array<Code>>;
  requestedSelectionPath: SelectionPath;
  schoolEducationLanguage?: Maybe<Code>;
  schoolEducationLanguageUrn?: Maybe<Scalars['String']>;
  snapshotDateTime?: Maybe<Scalars['String']>;
  snapshots?: Maybe<Array<StudyRight>>;
  state?: Maybe<Scalars['String']>;
  statePeriods?: Maybe<Array<StudyRightStatePeriod>>;
  studentId: Scalars['ID'];
  studyField?: Maybe<Code>;
  studyFieldUrn?: Maybe<Scalars['String']>;
  studyRightExpirationRulesUrn?: Maybe<Scalars['String']>;
  studyRightGraduation?: Maybe<StudyRightGraduation>;
  studyRightPrimalities?: Maybe<Array<StudyRightPrimality>>;
  studyRightTransfer?: Maybe<StudyRightTransfer>;
  studyStartDate?: Maybe<Scalars['String']>;
  termRegistrations?: Maybe<Array<TermRegistration>>;
  transferOutDate?: Maybe<Scalars['String']>;
  transferOutUniversityUrn?: Maybe<Scalars['String']>;
  tuitionFeeObligationPeriods?: Maybe<Array<TuitionFeeObligationPeriod>>;
  valid?: Maybe<DatePeriod>;
};

export type StudyRightCourseUnitSelection = {
  __typename?: 'StudyRightCourseUnitSelection';
  courseUnitGroupId?: Maybe<Scalars['ID']>;
  module?: Maybe<Module>;
  selectionType?: Maybe<Scalars['String']>;
  validityPeriod?: Maybe<DatePeriod>;
};


export type StudyRightCourseUnitSelectionModuleArgs = {
  universityOrgId: Scalars['ID'];
};

export type StudyRightGraduation = {
  __typename?: 'StudyRightGraduation';
  phase1GraduationDate: Scalars['String'];
  phase2GraduationDate?: Maybe<Scalars['String']>;
};

export type StudyRightMinorSelection = {
  __typename?: 'StudyRightMinorSelection';
  acceptanceDate?: Maybe<Scalars['String']>;
  acceptorPersonId?: Maybe<Scalars['ID']>;
  moduleGroupId?: Maybe<Scalars['ID']>;
  selectionState: Scalars['String'];
  selectionType: Scalars['String'];
  validityPeriod?: Maybe<DatePeriod>;
};

export type StudyRightModuleSelection = {
  __typename?: 'StudyRightModuleSelection';
  module?: Maybe<Module>;
  moduleGroupId?: Maybe<Scalars['ID']>;
  validityPeriod?: Maybe<DatePeriod>;
};


export type StudyRightModuleSelectionModuleArgs = {
  universityOrgId: Scalars['ID'];
};

export type StudyRightPrimality = {
  __typename?: 'StudyRightPrimality';
  documentState: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  studentId: Scalars['ID'];
  studyRightId: Scalars['ID'];
};

export type StudyRightPrimalityChain = {
  __typename?: 'StudyRightPrimalityChain';
  studentId: Scalars['ID'];
  studyRightPrimalities?: Maybe<Array<StudyRightPrimality>>;
};

export type StudyRightStatePeriod = {
  __typename?: 'StudyRightStatePeriod';
  endDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type StudyRightTermRegistrations = {
  __typename?: 'StudyRightTermRegistrations';
  documentState: Scalars['String'];
  statePeriodOverrides?: Maybe<Array<StudyRightStatePeriod>>;
  statePeriods?: Maybe<Array<StudyRightStatePeriod>>;
  studentId: Scalars['ID'];
  studyRight?: Maybe<StudyRight>;
  studyRightId: Scalars['ID'];
  termRegistrations: Array<TermRegistration>;
};

export type StudyRightTransfer = {
  __typename?: 'StudyRightTransfer';
  originalStartDate: Scalars['String'];
  originalUniversity?: Maybe<Code>;
  originalUniversityUrn?: Maybe<Scalars['String']>;
  transferComments?: Maybe<Scalars['String']>;
  usedAbsenceTerms?: Maybe<Scalars['Int']>;
  usedStatutoryAbsenceTerms?: Maybe<Scalars['Int']>;
  usedTerms?: Maybe<Scalars['Int']>;
};

export type StudySubGroup = {
  __typename?: 'StudySubGroup';
  cancelled: Scalars['Boolean'];
  documentState: Scalars['String'];
  id: Scalars['ID'];
  name: LocalizedString;
  size?: Maybe<Scalars['Int']>;
  studyEventIds?: Maybe<Array<Scalars['ID']>>;
  studyEvents?: Maybe<Array<StudyEvent>>;
  teacherIds?: Maybe<Array<Scalars['ID']>>;
  teachers?: Maybe<Array<PublicPerson>>;
};

export type StudyTerm = {
  __typename?: 'StudyTerm';
  name: LocalizedString;
  studyPeriods: Array<StudyPeriod>;
  valid: DatePeriod;
};

export type StudyTermLocator = {
  __typename?: 'StudyTermLocator';
  studyYearStartYear: Scalars['Int'];
  termIndex: Scalars['Int'];
};

export type Substitution = {
  __typename?: 'Substitution';
  courseUnitGroups?: Maybe<Array<CourseUnitSubstitution>>;
};

export type TermRegistration = {
  __typename?: 'TermRegistration';
  grants?: Maybe<Array<Grant>>;
  localId: Scalars['ID'];
  payments: Array<StudentPayment>;
  registrationDate?: Maybe<Scalars['String']>;
  statutoryAbsence: Scalars['Boolean'];
  statutoryAbsenceChangedBy?: Maybe<Scalars['String']>;
  statutoryAbsenceDate?: Maybe<Scalars['String']>;
  studyRight: StudyRight;
  studyRightId: Scalars['ID'];
  studyTerm?: Maybe<StudyTerm>;
  studyTermLocator: StudyTermLocator;
  termRegistrationType: Scalars['String'];
  tuitionFeePaymentState?: Maybe<TuitionFeePaymentState>;
};

export type TermRegistrationRequirements = {
  __typename?: 'TermRegistrationRequirements';
  documentState: Scalars['String'];
  requirements: Array<EducationTypeTermRegistrationRequirements>;
  universityOrgId: Scalars['ID'];
};

export type Thesis = {
  __typename?: 'Thesis';
  attainment?: Maybe<Attainment>;
  attainmentId?: Maybe<Scalars['String']>;
  commissionType: Scalars['String'];
  courseUnit: CourseUnit;
  courseUnitGroupId: Scalars['ID'];
  courseUnitId: Scalars['String'];
  id: Scalars['ID'];
  organisations?: Maybe<Array<OrganisationShare>>;
  person: PrivatePerson;
  personId: Scalars['String'];
  publicInspectionDate?: Maybe<Scalars['String']>;
  responsibilityInfos: Array<PersonWithAttainmentAcceptorType>;
  state: Scalars['String'];
  subject?: Maybe<LocalizedString>;
  thesisType: Code;
  thesisTypeUrn: Scalars['String'];
  title?: Maybe<LocalizedString>;
};

export type TimingTemplate = {
  __typename?: 'TimingTemplate';
  courseUnitTimings: Array<CourseUnitTiming>;
  id: Scalars['ID'];
  module: Module;
  moduleId: Scalars['ID'];
  moduleTimings: Array<ModuleTiming>;
  name: LocalizedString;
  studyYear: Scalars['Int'];
  universityOrgId: Scalars['ID'];
};

export type TuitionFeeObligationPeriod = {
  __typename?: 'TuitionFeeObligationPeriod';
  additionalInfo?: Maybe<LocalizedString>;
  exempt: Scalars['Boolean'];
  id: Scalars['ID'];
  studyRight?: Maybe<StudyRight>;
  studyRightId: Scalars['ID'];
  tuitionFee: Scalars['Float'];
  valid: DatePeriod;
};

export enum TuitionFeePaymentState {
  Outstanding = 'OUTSTANDING',
  Paid = 'PAID'
}

export type UniversityTermRegistration = {
  __typename?: 'UniversityTermRegistration';
  studyTerm: StudyTerm;
  studyTermLocator: StudyTermLocator;
  termRegistrationType: Scalars['String'];
  universityOrgId: Scalars['String'];
};

export type YearRange = {
  __typename?: 'YearRange';
  end?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
};

export type EnrichedAssessmentItemsForOpenUniProductQueryVariables = Exact<{
  assessmentItemIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type EnrichedAssessmentItemsForOpenUniProductQuery = { __typename?: 'Query', searchResult: Array<{ __typename?: 'AssessmentItem', id: string, credits: { __typename?: 'CreditRange', min?: number | null, max?: number | null }, name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null }, courseUnitRealisations: Array<{ __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, tweetText?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, studyGroupSets?: Array<{ __typename?: 'StudyGroupSet', localId: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, studySubGroups?: Array<{ __typename?: 'StudySubGroup', id: string, teacherIds?: Array<string> | null, cancelled: boolean, size?: number | null, name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null }, studyEvents?: Array<{ __typename?: 'StudyEvent', recursEvery?: string | null, recursUntil?: string | null, duration?: string | null, startTime?: string | null, cancellations?: Array<string> | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, events?: Array<{ __typename?: 'StudyEventRealisation', start?: string | null, end?: string | null, duration?: string | null }> | null, locations?: Array<{ __typename?: 'Location', building?: { __typename?: 'Building', address?: { __typename?: 'Address', city?: string | null, postalCode?: string | null, streetAddress?: string | null, country?: { __typename?: 'Code', name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } } | null } | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null }> | null }> | null }> | null, subGroupRange?: { __typename?: 'Range', min?: number | null, max?: number | null } | null }> | null, enrolmentQuestionnaire?: { __typename?: 'EnrolmentQuestionnaire', courseUnitRealisationId: string, enrolmentQuestions?: Array<{ __typename?: 'EnrolmentQuestion', localId: string, required: boolean, questionType?: string | null, question?: { __typename?: 'LocalizedMarkupString', sv?: string | null, en?: string | null, fi?: string | null } | null, selections?: Array<{ __typename?: 'EnrolmentQuestionSelect', value: string, option: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } }> | null }> | null } | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, organisations?: Array<{ __typename?: 'CourseUnitRealisationOrganisation', organisation?: { __typename?: 'Organisation', id: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null }> | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null }> }> };

export type SearchMyUpcomingTeachingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  uiLang?: InputMaybe<Scalars['String']>;
  codeUrns?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  continuousEnrolment?: InputMaybe<Scalars['Boolean']>;
  hiddenCurIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  fetchOnlyHiddenCurs?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchMyUpcomingTeachingQuery = { __typename?: 'Query', searchResult: { __typename?: 'CourseUnitRealisationTeacherSearchResult', hiddenTotal: number, total: number, searchResults: Array<{ __typename?: 'CourseUnitRealisationFullResultItem', langMatch?: string | null, courseUnitCodes?: string | null, courseUnitRealisation?: { __typename?: 'CourseUnitRealisation', publishDate?: string | null, flowState?: string | null, id: string, assessmentItemIds?: Array<string> | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } } | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null }> } };

export type SearchMyEnrolmentTeachingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  uiLang?: InputMaybe<Scalars['String']>;
  codeUrns?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  continuousEnrolment?: InputMaybe<Scalars['Boolean']>;
  hiddenCurIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  fetchOnlyHiddenCurs?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchMyEnrolmentTeachingQuery = { __typename?: 'Query', searchResult: { __typename?: 'CourseUnitRealisationTeacherSearchResult', hiddenTotal: number, total: number, searchResults: Array<{ __typename?: 'CourseUnitRealisationFullResultItem', langMatch?: string | null, courseUnitCodes?: string | null, courseUnitRealisation?: { __typename?: 'CourseUnitRealisation', totalEnrolmentCount?: number | null, unconfirmedEnrolmentCount?: number | null, id: string, assessmentItemIds?: Array<string> | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } } | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null }> } };

export type SearchMyOngoingTeachingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  uiLang?: InputMaybe<Scalars['String']>;
  codeUrns?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  continuousEnrolment?: InputMaybe<Scalars['Boolean']>;
  hiddenCurIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  fetchOnlyHiddenCurs?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchMyOngoingTeachingQuery = { __typename?: 'Query', searchResult: { __typename?: 'CourseUnitRealisationTeacherSearchResult', hiddenTotal: number, total: number, searchResults: Array<{ __typename?: 'CourseUnitRealisationFullResultItem', langMatch?: string | null, courseUnitCodes?: string | null, courseUnitRealisation?: { __typename?: 'CourseUnitRealisation', lateEnrolmentEnd?: string | null, id: string, assessmentItemIds?: Array<string> | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } } | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null }> } };

export type SearchMyEvaluationTeachingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  evaluationPeriod?: InputMaybe<DatePeriodInput>;
  start?: InputMaybe<Scalars['Int']>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  uiLang?: InputMaybe<Scalars['String']>;
  codeUrns?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  continuousEnrolment?: InputMaybe<Scalars['Boolean']>;
  hiddenCurIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  fetchOnlyHiddenCurs?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchMyEvaluationTeachingQuery = { __typename?: 'Query', searchResult: { __typename?: 'CourseUnitRealisationTeacherSearchResult', hiddenTotal: number, total: number, searchResults: Array<{ __typename?: 'CourseUnitRealisationFullResultItem', langMatch?: string | null, courseUnitCodes?: string | null, courseUnitRealisation?: { __typename?: 'CourseUnitRealisation', enrolledEnrolmentCount?: number | null, id: string, assessmentItemIds?: Array<string> | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } } | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null }> } };

export type SearchMyPastArchivedAndCancelledTeachingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
  activityEnd?: InputMaybe<Scalars['String']>;
  fullTextQuery?: InputMaybe<Scalars['String']>;
  uiLang?: InputMaybe<Scalars['String']>;
  codeUrns?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  continuousEnrolment?: InputMaybe<Scalars['Boolean']>;
  hiddenCurIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  fetchOnlyHiddenCurs?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchMyPastArchivedAndCancelledTeachingQuery = { __typename?: 'Query', searchResult: { __typename?: 'CourseUnitRealisationTeacherSearchResult', hiddenTotal: number, total: number, searchResults: Array<{ __typename?: 'CourseUnitRealisationFullResultItem', langMatch?: string | null, courseUnitCodes?: string | null, courseUnitRealisation?: { __typename?: 'CourseUnitRealisation', id: string, assessmentItemIds?: Array<string> | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } } | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null }> } };

export type CourseUnitRealisationBaseInfoFragment = { __typename?: 'CourseUnitRealisation', id: string, assessmentItemIds?: Array<string> | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } };

export type CourseUnitRealisationFullSearchResultHighlightsFragment = { __typename?: 'CourseUnitRealisationFullResultItem', langMatch?: string | null, courseUnitCodes?: string | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null };

export type AllLanguagesFragment = { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null };

export type MetadataFragment = { __typename?: 'Metadata', createdBy?: string | null, createdOn?: string | null, lastModifiedBy?: string | null, lastModifiedOn?: string | null, modificationOrdinal?: number | null, revision?: number | null };

export type CourseUnitRealisationViewFragment = { __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, organisations?: Array<{ __typename?: 'CourseUnitRealisationOrganisation', organisation?: { __typename?: 'Organisation', id: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null }> | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null };

export type CourseUnitRealisationFragment = { __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null };

export type EnrolmentConstraintFragment = { __typename?: 'EnrolmentConstraint', assessmentItemId: string, allowedCourseUnitRealisationIds?: Array<string> | null, maxNumberOfEnrolments?: number | null, overrideEnrolmentPeriodForCURIds?: Array<string> | null };

export type EnrolmentConstraintViewFragment = { __typename?: 'EnrolmentConstraint', assessmentItemId: string, allowedCourseUnitRealisationIds?: Array<string> | null, maxNumberOfEnrolments?: number | null, overrideEnrolmentPeriodForCURIds?: Array<string> | null, assessmentItem?: { __typename?: 'AssessmentItem', id: string, universityOrgIds?: Array<string> | null, name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null }, credits: { __typename?: 'CreditRange', min?: number | null, max?: number | null } } | null, allPossibleCourseUnitRealisations?: Array<{ __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, organisations?: Array<{ __typename?: 'CourseUnitRealisationOrganisation', organisation?: { __typename?: 'Organisation', id: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null }> | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null }> | null, allowedCourseUnitRealisations?: Array<{ __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, organisations?: Array<{ __typename?: 'CourseUnitRealisationOrganisation', organisation?: { __typename?: 'Organisation', id: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null }> | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null }> | null };

export type OpenUniversityProductFragment = { __typename?: 'OpenUniversityProduct', id: string, documentState: string, flowState: string, price: string, credits: number, publishedOn?: string | null, cancelledOn?: string | null, educationId: string, organisationId: string, productCodeId?: string | null, courseUnitId: string, completionMethodId: string, universityOrgIds?: Array<string> | null, codeUrns?: Array<string> | null, name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null }, description?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, salesPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null, validityPeriod?: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } | null, enrolmentConstraints?: Array<{ __typename?: 'EnrolmentConstraint', assessmentItemId: string, allowedCourseUnitRealisationIds?: Array<string> | null, maxNumberOfEnrolments?: number | null, overrideEnrolmentPeriodForCURIds?: Array<string> | null }> | null, metadata?: { __typename?: 'Metadata', createdBy?: string | null, createdOn?: string | null, lastModifiedBy?: string | null, lastModifiedOn?: string | null, modificationOrdinal?: number | null, revision?: number | null } | null, collaborationInstitution?: { __typename?: 'CollaborationInstitution', educationalInstitutionUrn?: string | null, internationalInstitutionUrn?: string | null } | null };

export type OpenUniversityProductViewFragment = { __typename?: 'OpenUniversityProduct', id: string, documentState: string, flowState: string, price: string, credits: number, publishedOn?: string | null, cancelledOn?: string | null, educationId: string, organisationId: string, productCodeId?: string | null, courseUnitId: string, completionMethodId: string, universityOrgIds?: Array<string> | null, codeUrns?: Array<string> | null, education?: { __typename?: 'Education', name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, organisation?: { __typename?: 'Organisation', name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, completionMethod?: { __typename?: 'CompletionMethod', assessmentItemIds: Array<string>, prerequisites?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, evaluationCriteria?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, productCode?: { __typename?: 'OpenUniversityProductCode', id: string, code: string, paymentSystem: string, description?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, enrolmentConstraints?: Array<{ __typename?: 'EnrolmentConstraint', assessmentItemId: string, allowedCourseUnitRealisationIds?: Array<string> | null, maxNumberOfEnrolments?: number | null, overrideEnrolmentPeriodForCURIds?: Array<string> | null, assessmentItem?: { __typename?: 'AssessmentItem', id: string, universityOrgIds?: Array<string> | null, name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null }, credits: { __typename?: 'CreditRange', min?: number | null, max?: number | null } } | null, allPossibleCourseUnitRealisations?: Array<{ __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, organisations?: Array<{ __typename?: 'CourseUnitRealisationOrganisation', organisation?: { __typename?: 'Organisation', id: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null }> | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null }> | null, allowedCourseUnitRealisations?: Array<{ __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, organisations?: Array<{ __typename?: 'CourseUnitRealisationOrganisation', organisation?: { __typename?: 'Organisation', id: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null }> | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null }> | null }> | null, soldAmount?: { __typename?: 'OpenUniversityProductSoldAmount', amountSold?: number | null } | null, name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null }, description?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, salesPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null, validityPeriod?: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } | null, metadata?: { __typename?: 'Metadata', createdBy?: string | null, createdOn?: string | null, lastModifiedBy?: string | null, lastModifiedOn?: string | null, modificationOrdinal?: number | null, revision?: number | null } | null, collaborationInstitution?: { __typename?: 'CollaborationInstitution', educationalInstitutionUrn?: string | null, internationalInstitutionUrn?: string | null } | null };

export type OpenUniversityProductViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OpenUniversityProductViewQuery = { __typename?: 'Query', open_university_product: { __typename?: 'OpenUniversityProduct', id: string, documentState: string, flowState: string, price: string, credits: number, publishedOn?: string | null, cancelledOn?: string | null, educationId: string, organisationId: string, productCodeId?: string | null, courseUnitId: string, completionMethodId: string, universityOrgIds?: Array<string> | null, codeUrns?: Array<string> | null, education?: { __typename?: 'Education', name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, organisation?: { __typename?: 'Organisation', name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, completionMethod?: { __typename?: 'CompletionMethod', assessmentItemIds: Array<string>, prerequisites?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, evaluationCriteria?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, productCode?: { __typename?: 'OpenUniversityProductCode', id: string, code: string, paymentSystem: string, description?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null, enrolmentConstraints?: Array<{ __typename?: 'EnrolmentConstraint', assessmentItemId: string, allowedCourseUnitRealisationIds?: Array<string> | null, maxNumberOfEnrolments?: number | null, overrideEnrolmentPeriodForCURIds?: Array<string> | null, assessmentItem?: { __typename?: 'AssessmentItem', id: string, universityOrgIds?: Array<string> | null, name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null }, credits: { __typename?: 'CreditRange', min?: number | null, max?: number | null } } | null, allPossibleCourseUnitRealisations?: Array<{ __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, organisations?: Array<{ __typename?: 'CourseUnitRealisationOrganisation', organisation?: { __typename?: 'Organisation', id: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null }> | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null }> | null, allowedCourseUnitRealisations?: Array<{ __typename?: 'CourseUnitRealisation', id: string, flowState?: string | null, documentState: string, assessmentItemIds?: Array<string> | null, teachingLanguageUrn?: string | null, publishDate?: string | null, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, nameSpecifier?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, organisations?: Array<{ __typename?: 'CourseUnitRealisationOrganisation', organisation?: { __typename?: 'Organisation', id: string, name?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null } | null }> | null, activityPeriod: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null }, enrolmentPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null }> | null }> | null, soldAmount?: { __typename?: 'OpenUniversityProductSoldAmount', amountSold?: number | null } | null, name: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null }, description?: { __typename?: 'LocalizedString', fi?: string | null, sv?: string | null, en?: string | null } | null, salesPeriod?: { __typename?: 'DateTimePeriod', startDateTime?: string | null, endDateTime?: string | null } | null, validityPeriod?: { __typename?: 'DatePeriod', startDate?: string | null, endDate?: string | null } | null, metadata?: { __typename?: 'Metadata', createdBy?: string | null, createdOn?: string | null, lastModifiedBy?: string | null, lastModifiedOn?: string | null, modificationOrdinal?: number | null, revision?: number | null } | null, collaborationInstitution?: { __typename?: 'CollaborationInstitution', educationalInstitutionUrn?: string | null, internationalInstitutionUrn?: string | null } | null } };

export const AllLanguagesFragmentDoc = gql`
    fragment allLanguages on LocalizedString {
  fi
  sv
  en
}
    `;
export const CourseUnitRealisationBaseInfoFragmentDoc = gql`
    fragment CourseUnitRealisationBaseInfo on CourseUnitRealisation {
  id
  assessmentItemIds
  name {
    ...allLanguages
  }
  nameSpecifier {
    ...allLanguages
  }
  activityPeriod {
    startDate
    endDate
  }
}
    ${AllLanguagesFragmentDoc}`;
export const CourseUnitRealisationFullSearchResultHighlightsFragmentDoc = gql`
    fragment CourseUnitRealisationFullSearchResultHighlights on CourseUnitRealisationFullResultItem {
  langMatch
  courseUnitCodes
  name {
    ...allLanguages
  }
  nameSpecifier {
    ...allLanguages
  }
}
    ${AllLanguagesFragmentDoc}`;
export const EnrolmentConstraintFragmentDoc = gql`
    fragment EnrolmentConstraint on EnrolmentConstraint {
  assessmentItemId
  allowedCourseUnitRealisationIds
  maxNumberOfEnrolments
  overrideEnrolmentPeriodForCURIds
}
    `;
export const MetadataFragmentDoc = gql`
    fragment Metadata on Metadata {
  createdBy
  createdOn
  lastModifiedBy
  lastModifiedOn
  modificationOrdinal
  revision
}
    `;
export const OpenUniversityProductFragmentDoc = gql`
    fragment OpenUniversityProduct on OpenUniversityProduct {
  id
  name {
    ...allLanguages
  }
  documentState
  flowState
  description {
    ...allLanguages
  }
  price
  credits
  publishedOn
  cancelledOn
  salesPeriod {
    startDateTime
    endDateTime
  }
  validityPeriod {
    startDate
    endDate
  }
  educationId
  organisationId
  productCodeId
  courseUnitId
  completionMethodId
  enrolmentConstraints {
    ...EnrolmentConstraint
  }
  metadata {
    ...Metadata
  }
  universityOrgIds
  codeUrns
  collaborationInstitution {
    educationalInstitutionUrn
    internationalInstitutionUrn
  }
}
    ${AllLanguagesFragmentDoc}
${EnrolmentConstraintFragmentDoc}
${MetadataFragmentDoc}`;
export const CourseUnitRealisationFragmentDoc = gql`
    fragment CourseUnitRealisation on CourseUnitRealisation {
  id
  flowState
  documentState
  assessmentItemIds
  teachingLanguageUrn
  publishDate
  activityPeriod {
    startDate
    endDate
  }
  enrolmentPeriod {
    startDateTime
    endDateTime
  }
}
    `;
export const CourseUnitRealisationViewFragmentDoc = gql`
    fragment CourseUnitRealisationView on CourseUnitRealisation {
  ...CourseUnitRealisation
  name {
    ...allLanguages
  }
  nameSpecifier {
    ...allLanguages
  }
  organisations {
    organisation {
      id
      name {
        ...allLanguages
      }
    }
  }
}
    ${CourseUnitRealisationFragmentDoc}
${AllLanguagesFragmentDoc}`;
export const EnrolmentConstraintViewFragmentDoc = gql`
    fragment EnrolmentConstraintView on EnrolmentConstraint {
  ...EnrolmentConstraint
  assessmentItem {
    id
    name {
      ...allLanguages
    }
    credits {
      min
      max
    }
    universityOrgIds
  }
  allPossibleCourseUnitRealisations {
    ...CourseUnitRealisationView
  }
  allowedCourseUnitRealisations {
    ...CourseUnitRealisationView
  }
}
    ${EnrolmentConstraintFragmentDoc}
${AllLanguagesFragmentDoc}
${CourseUnitRealisationViewFragmentDoc}`;
export const OpenUniversityProductViewFragmentDoc = gql`
    fragment OpenUniversityProductView on OpenUniversityProduct {
  ...OpenUniversityProduct
  education {
    name {
      ...allLanguages
    }
  }
  organisation {
    name {
      ...allLanguages
    }
  }
  completionMethod {
    prerequisites {
      ...allLanguages
    }
    evaluationCriteria {
      ...allLanguages
    }
    assessmentItemIds
  }
  productCode {
    id
    code
    description {
      ...allLanguages
    }
    paymentSystem
  }
  enrolmentConstraints {
    ...EnrolmentConstraintView
  }
  soldAmount {
    amountSold
  }
}
    ${OpenUniversityProductFragmentDoc}
${AllLanguagesFragmentDoc}
${EnrolmentConstraintViewFragmentDoc}`;
export const EnrichedAssessmentItemsForOpenUniProductDocument = gql`
    query enrichedAssessmentItemsForOpenUniProduct($assessmentItemIds: [ID!]!) {
  searchResult: assessment_items(assessmentItemIds: $assessmentItemIds) {
    id
    credits {
      min
      max
    }
    name {
      ...allLanguages
    }
    courseUnitRealisations(
      activityStatus: "ONGOING_AND_FUTURE"
      flowStates: ["PUBLISHED"]
      documentStates: ["ACTIVE"]
      removeCursPublishDateInFuture: true
    ) {
      ...CourseUnitRealisationView
      tweetText {
        ...allLanguages
      }
      studyGroupSets {
        localId
        name {
          ...allLanguages
        }
        studySubGroups(removeCancelled: true) {
          id
          name {
            ...allLanguages
          }
          studyEvents {
            recursEvery
            recursUntil
            duration
            name {
              ...allLanguages
            }
            startTime
            cancellations
            events {
              start
              end
              duration
            }
            locations {
              building {
                address {
                  city
                  country {
                    name {
                      ...allLanguages
                    }
                  }
                  postalCode
                  streetAddress
                }
                name {
                  ...allLanguages
                }
              }
              name {
                ...allLanguages
              }
            }
          }
          teacherIds
          cancelled
          size
        }
        subGroupRange {
          min
          max
        }
      }
      enrolmentQuestionnaire {
        courseUnitRealisationId
        enrolmentQuestions {
          localId
          required
          questionType
          question {
            sv
            en
            fi
          }
          selections {
            value
            option {
              ...allLanguages
            }
          }
        }
      }
    }
  }
}
    ${AllLanguagesFragmentDoc}
${CourseUnitRealisationViewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnrichedAssessmentItemsForOpenUniProductQueryService extends Apollo.Query<EnrichedAssessmentItemsForOpenUniProductQuery, EnrichedAssessmentItemsForOpenUniProductQueryVariables> {
    document = EnrichedAssessmentItemsForOpenUniProductDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMyUpcomingTeachingDocument = gql`
    query SearchMyUpcomingTeaching($limit: Int, $start: Int, $fullTextQuery: String, $uiLang: String, $codeUrns: [String!], $continuousEnrolment: Boolean, $hiddenCurIds: [ID!], $fetchOnlyHiddenCurs: Boolean) {
  searchResult: search_course_unit_realisations_for_teacher(
    fetchOnlyHiddenCurs: $fetchOnlyHiddenCurs
    hiddenCurIds: $hiddenCurIds
    uiLang: $uiLang
    fullTextQuery: $fullTextQuery
    activityStatus: "FUTURE"
    flowStates: ["PUBLISHED", "NOT_READY"]
    enrolmentOngoing: false
    sort: "nameSpecifier,name,activityPeriod"
    codeUrns: $codeUrns
    continuousEnrolment: $continuousEnrolment
    limit: $limit
    start: $start
  ) {
    hiddenTotal
    total
    searchResults {
      ...CourseUnitRealisationFullSearchResultHighlights
      courseUnitRealisation {
        ...CourseUnitRealisationBaseInfo
        publishDate
        flowState
      }
    }
  }
}
    ${CourseUnitRealisationFullSearchResultHighlightsFragmentDoc}
${CourseUnitRealisationBaseInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMyUpcomingTeachingQueryService extends Apollo.Query<SearchMyUpcomingTeachingQuery, SearchMyUpcomingTeachingQueryVariables> {
    document = SearchMyUpcomingTeachingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMyEnrolmentTeachingDocument = gql`
    query SearchMyEnrolmentTeaching($limit: Int, $start: Int, $fullTextQuery: String, $uiLang: String, $codeUrns: [String!], $continuousEnrolment: Boolean, $hiddenCurIds: [ID!], $fetchOnlyHiddenCurs: Boolean) {
  searchResult: search_course_unit_realisations_for_teacher(
    fetchOnlyHiddenCurs: $fetchOnlyHiddenCurs
    hiddenCurIds: $hiddenCurIds
    uiLang: $uiLang
    fullTextQuery: $fullTextQuery
    activityStatus: "ONGOING_AND_FUTURE"
    flowStates: ["PUBLISHED", "NOT_READY"]
    sort: "nameSpecifier,name,activityPeriod"
    codeUrns: $codeUrns
    continuousEnrolment: $continuousEnrolment
    enrolmentOngoing: true
    limit: $limit
    start: $start
  ) {
    hiddenTotal
    total
    searchResults {
      ...CourseUnitRealisationFullSearchResultHighlights
      courseUnitRealisation {
        ...CourseUnitRealisationBaseInfo
        totalEnrolmentCount
        unconfirmedEnrolmentCount
      }
    }
  }
}
    ${CourseUnitRealisationFullSearchResultHighlightsFragmentDoc}
${CourseUnitRealisationBaseInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMyEnrolmentTeachingQueryService extends Apollo.Query<SearchMyEnrolmentTeachingQuery, SearchMyEnrolmentTeachingQueryVariables> {
    document = SearchMyEnrolmentTeachingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMyOngoingTeachingDocument = gql`
    query SearchMyOngoingTeaching($limit: Int, $start: Int, $fullTextQuery: String, $uiLang: String, $codeUrns: [String!], $continuousEnrolment: Boolean, $hiddenCurIds: [ID!], $fetchOnlyHiddenCurs: Boolean) {
  searchResult: search_course_unit_realisations_for_teacher(
    fetchOnlyHiddenCurs: $fetchOnlyHiddenCurs
    hiddenCurIds: $hiddenCurIds
    uiLang: $uiLang
    fullTextQuery: $fullTextQuery
    activityStatus: "ONGOING"
    flowStates: ["PUBLISHED", "NOT_READY"]
    sort: "nameSpecifier,name,activityPeriod"
    codeUrns: $codeUrns
    continuousEnrolment: $continuousEnrolment
    limit: $limit
    start: $start
  ) {
    hiddenTotal
    total
    searchResults {
      ...CourseUnitRealisationFullSearchResultHighlights
      courseUnitRealisation {
        ...CourseUnitRealisationBaseInfo
        lateEnrolmentEnd
      }
    }
  }
}
    ${CourseUnitRealisationFullSearchResultHighlightsFragmentDoc}
${CourseUnitRealisationBaseInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMyOngoingTeachingQueryService extends Apollo.Query<SearchMyOngoingTeachingQuery, SearchMyOngoingTeachingQueryVariables> {
    document = SearchMyOngoingTeachingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMyEvaluationTeachingDocument = gql`
    query SearchMyEvaluationTeaching($limit: Int, $evaluationPeriod: DatePeriodInput, $start: Int, $fullTextQuery: String, $uiLang: String, $codeUrns: [String!], $continuousEnrolment: Boolean, $hiddenCurIds: [ID!], $fetchOnlyHiddenCurs: Boolean) {
  searchResult: search_course_unit_realisations_for_teacher(
    fetchOnlyHiddenCurs: $fetchOnlyHiddenCurs
    hiddenCurIds: $hiddenCurIds
    uiLang: $uiLang
    fullTextQuery: $fullTextQuery
    activityStatus: "ALL"
    evaluationPeriod: $evaluationPeriod
    flowStates: ["PUBLISHED", "NOT_READY"]
    sort: "nameSpecifier,name,activityPeriod"
    codeUrns: $codeUrns
    continuousEnrolment: $continuousEnrolment
    limit: $limit
    start: $start
  ) {
    hiddenTotal
    total
    searchResults {
      ...CourseUnitRealisationFullSearchResultHighlights
      courseUnitRealisation {
        ...CourseUnitRealisationBaseInfo
        enrolledEnrolmentCount
      }
    }
  }
}
    ${CourseUnitRealisationFullSearchResultHighlightsFragmentDoc}
${CourseUnitRealisationBaseInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMyEvaluationTeachingQueryService extends Apollo.Query<SearchMyEvaluationTeachingQuery, SearchMyEvaluationTeachingQueryVariables> {
    document = SearchMyEvaluationTeachingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMyPastArchivedAndCancelledTeachingDocument = gql`
    query SearchMyPastArchivedAndCancelledTeaching($limit: Int, $start: Int, $activityEnd: String, $fullTextQuery: String, $uiLang: String, $codeUrns: [String!], $continuousEnrolment: Boolean, $hiddenCurIds: [ID!], $fetchOnlyHiddenCurs: Boolean) {
  searchResult: search_course_unit_realisations_for_teacher(
    fetchOnlyHiddenCurs: $fetchOnlyHiddenCurs
    hiddenCurIds: $hiddenCurIds
    uiLang: $uiLang
    fullTextQuery: $fullTextQuery
    activityStatus: "ALL"
    activityEnd: $activityEnd
    getPastArchivedAndCancelled: true
    sort: "-activityPeriod"
    codeUrns: $codeUrns
    continuousEnrolment: $continuousEnrolment
    start: $start
    limit: $limit
  ) {
    hiddenTotal
    total
    searchResults {
      ...CourseUnitRealisationFullSearchResultHighlights
      courseUnitRealisation {
        ...CourseUnitRealisationBaseInfo
      }
    }
  }
}
    ${CourseUnitRealisationFullSearchResultHighlightsFragmentDoc}
${CourseUnitRealisationBaseInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMyPastArchivedAndCancelledTeachingQueryService extends Apollo.Query<SearchMyPastArchivedAndCancelledTeachingQuery, SearchMyPastArchivedAndCancelledTeachingQueryVariables> {
    document = SearchMyPastArchivedAndCancelledTeachingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OpenUniversityProductViewDocument = gql`
    query OpenUniversityProductView($id: ID!) {
  open_university_product(id: $id) {
    ...OpenUniversityProductView
  }
}
    ${OpenUniversityProductViewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OpenUniversityProductViewQueryService extends Apollo.Query<OpenUniversityProductViewQuery, OpenUniversityProductViewQueryVariables> {
    document = OpenUniversityProductViewDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
